import React from 'react'
import {
    TrainingsOverviewMetaProps,
    AllocationsOverviewMetaProps,
    AdminHubMetaProps,
    AdminSettingsMetaProps,
    AdminTrainingsMetaProps,
    AreaFormModalMetaProps,
    AssignTrainingFormModalMetaProps,
    ConfirmationModalMetaProps,
    DeleteAreaMetaProps,
    DeleteDutyMetaProps,
    DeleteEventMetaProps,
    DeletePreferenceMetaProps,
    DeleteFlagMetaProps,
    DeleteShiftMetaProps,
    DocumentViewerMetaProps,
    DuplicateAreaModalMetaProps,
    DuplicateEventModalMetaProps,
    DutyCardMetaProps,
    DutyFormModalMetaProps,
    DutyMetaProps,
    EventCardMetaProps,
    EventDetailMetaProps,
    EventFormModalMetaProps,
    EventsMetaProps,
    FooterMetaProps,
    HeaderMetaProps,
    HomeMetaProps,
    LoadingSpinnerMetaProps,
    LoginMetaProps,
    Nav,
    PreferenceCardMetaProps,
    PreferenceFormModalMetaProps,
    PreferenceMetaProps,
    FlagCardMetaProps,
    FlagFormModalMetaProps,
    FlagMetaProps,
    FlagCategoryFormModalMetaProps,
    UpdateFlagCategoryFormMetaProps,
    DeleteFlagCategoryMetaProps,
    ShiftFormModalMetaProps,
    DuplicateShiftModalMetaProps,
    CopyShiftAllocationsModalMetaProps,
    CompletionQuestionsModalMetaProps,
    TermsAndConditionsMetaProps,
    TrainingFormModalMetaProps,
    TrainingListMetaProps,
    TrainingModulePageMetaProps,
    UnsupportedModuleViewerMetaProps,
    UpdateAreaFormMetaProps,
    UpdateDutyFormMetaProps,
    UpdateEventFormMetaProps,
    UpdatePreferenceFormMetaProps,
    UpdateFlagFormMetaProps,
    UpdateShiftFormMetaProps,
    UpdateTrainingFormMetaProps,
    VideoPlayerMetaProps,
    VolunteerCardMetaProps,
    VolunteerFormModalMetaProps,
    VolunteerProfileMetaProps,
    VolunteersMetaProps,
    VolunteerTrainingPageDetailsMetaProps,
    VolunteerTrainingPageMetaProps,
    VolunteerPoliciesMetaProps,
    TrainingModuleMetaProps,
    AnnouncementMetaProps,
    AnnouncementFormModalMetaProps,
    AnnouncementViewModalMetaProps,
    BulkTrainingAssignmentFormMetaProps,
    ShiftAssignmentFormMetaProps,
    VolunteerFiltersWithConflictProps,
    UserFormModalMetaProps,
    UpdateUserFormMetaProps,
    DeleteUserMetaProps,
    LeadAssignModalPropsMeta,
    AccessColorMetaProps,
    AccessColorFormModalMetaProps,
    CoreTeamMetaProps,
    CoreTeamStatsMetaProps,
    CoreTeamTableMetaProps,
    RejectedCoreTeamTableMetaProps,
    CoreTeamFormModalMetaProps,
    CoreTeamAddModalMetaProps,
    Role,
    TrainingSequenceEditMetaProps,
    MaxChartSize,
    ManagementAnalyticsMetaProps,
    AnalyticsTab,
    VolunteerOverviewMetaProps,
    DashboardMetaProps,
    InternationalRegisterationsMetaProps,
    CoreStreamOverviewMetaProps,
    VolunteerStatsTableOverviewMetaProps,
    DidarAcknowledgementOverviewMetaProps,
    EmailCampaignsMetaProps,
    EmailCampaignFormMetaProps,
    EmailCampaignPreviewMetaProps,
    ShiftMoveModalMetaProps,
    VolunteerUploadDocumentFormMetaProps,
    AllocationStatusPageMetaProps,
    CheckInPageMetaProps,
    DutyStatusOverviewMetaProps,
    QuickAllocateModalMetaProps,
    LiveOperationsMetaProps,
    LiveStatusTab,
    LoginFormMetaProps,
    ForgetPasswordMetaProps,
    ResetPasswordMetaProps,
    SignupMetaProps,
    VerifyEmailMetaProps,
    HouseholdSelectionMetaProps,
    CheckInLoginFormMetaProps,
    PublicFormFillMetaProps,
    PublicFormsMetaProps,
    GuidelineFormModalMetaProps,
    AdminGuidelinesMetaProps,
    VolunteerGuidelinesMetaProps,
    GuidelineDetailsMetaProps,
    JVPointsMetaProps,
    DirectorVolunteerMetaProps
} from './types'
import { Link } from 'react-router-dom'
import { ExternalLinkIcon } from '../icons'

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api'
const IIUK_BASE_URL = process.env.REACT_APP_IIUK_BASE_URL || 'https://iiuk.org'

export const ROLE_MAP: { [key in Role]: string } = {
    volunteer: 'Volunteer',
    lead: 'Lead',
    super_lead: 'Super Lead',
    allocating_lead: 'Allocating Lead',
    reallocation_manager: 'Reallocation Manager',
    core_team: 'Core Team',
    core_team_approver: 'Core Team Approver',
    hr_team_member: 'HR Team Member',
    hr_deputy: 'HR Deputy',
    hr_admin: 'HR Administrator',
    admin: 'Administrator',
    checkin_volunteer: 'Check-In Volunteer',
    checkin_admin: 'Check-In Admin',
    lead_with_stats: 'Lead With Stats',
    jv_exec: 'JV Exec',
    jv_lead: 'JV Lead',
    iv_director: 'IV Director',
    iv_deputy_director: 'IV Deputy Director'
}

const HeaderNav: Nav = {
    home: { title: 'Home', path: `/` },
    profile: { title: 'Profile', path: `/profile` },
    trainings: { title: 'My Training', path: '/volunteer/training' },
    policies: { title: 'Policies', path: '/volunteer/policies' },
    //guidelines: { title: 'Guidelines', path: '/volunteer/guidelines' },
    events: { title: 'Events', path: '/events', show: (user) => user.permissions?.includes('view_events') && user.permissions.includes('view_admin_hub') },
    check_in: { title: 'Check In', path: '/admin/check-in', show: (user) => user.permissions?.includes('manage_check_ins') },
    coreTeam: { title: 'Core Team', path: '/core-team', show: (user) => user.permissions?.includes('view_core_team') },
    admin: { title: 'Admin', path: `/admin`, show: (user) => user.permissions?.includes('view_admin_hub') },
    faq: { title: 'FAQ', path: 'https://iv.iiuk.org/vms-faq/' },
}

export const HeaderMeta: HeaderMetaProps = {
    title: 'Volunteer Management System',
    themeToggleLightLabel: 'Switch to light mode',
    themeToggleDarkLabel: 'Switch to dark mode',
    themeToggleSystemLabel: 'Use system theme',
    languageSelectorLabel: 'Select language',
    logout: 'Log Out',
    loggingOutText: 'Logging out...',
    nav: HeaderNav
}

export const FooterMeta: FooterMetaProps = {
    nav: {
        termsAndCondition: 'Terms of Use',
        privacyNotice: 'Privacy Notice'
    },
    version: 2026,
    copyRight: 'All Rights Reserved'
}

export const TermsAndConditionsMeta: TermsAndConditionsMetaProps = {
    title: 'Volunteer Data Consent & Privacy Notice',
    content: `By registering, you acknowledge and agree that the Ismaili Volunteers VMS will collect and use your personal data to administer volunteering, including matching you to suitable duties and managing your training.

**What we store**: We will hold only relevant volunteer information, which may include full name, email address, mobile phone number, age band, duty preferences and skills. If you have a Disclosure & Barring Services check, we may capture this information also.

**Sharing your contact details (for volunteering purposes)**: To support volunteering activities, your contact details may be shared with the relevant team leader(s) within our committee or with relevant institution contacts (where appropriate) so they can contact you about volunteering duties, schedules, updates, and operational requirements.

**Training and duty logs**: You understand that your training activity (e.g., learning/training video completion) and duty participation/assignments may be recorded and logged against your volunteer profile for operational, safeguarding, and compliance purposes.

**Data protection**: We will process and store your data in accordance with the applicable rules and regulations, using appropriate technical and organisational security measures. Data will be retained only as long as necessary for volunteering administration and legal/compliance requirements.\n\nBy accepting, I confirm that I have read and agree to the above and consent to my data being processed for volunteer administration as described above.`,
    agreeButton: 'I Agree',
    disagreeButton: 'I Disagree'
}


export const AdminHubMeta: AdminHubMetaProps = {
    title: 'Admin Hub',
    description: 'Access all administrative tools and management features',
    dashboardTitle: 'Dashboard',
    dashboardDescription: 'Overview of users and volunteers',
    eventsTitle: 'Events',
    eventsDescription: 'Create and manage events, areas, and shifts',
    volunteersTitle: 'Volunteers',
    volunteersDescription: 'Manage volunteer profiles and assignments',
    trainingsTitle: 'Trainings',
    trainingsDescription: 'Create and manage training content and modules',
    dutiesTitle: 'Duties',
    dutiesDescription: 'Define and manage duty types for shifts',
    preferencesTitle: 'Preferences',
    preferencesDescription: 'Manage volunteer preferences and availability',
    flagsTitle: 'Flags',
    flagsDescription: 'Manage volunteer flags and attributes',
    settingsTitle: 'System Settings',
    settingsDescription: 'Configure system-wide settings and perform bulk actions',
    announcementsTitle: 'Announcements',
    announcementsDescription: 'Post announcements to keep all volunteers up to date',
    userTitle: 'User Management',
    userDescription: 'Manage users and roles with access control',
    accessColorTitle: 'Access Colors',
    accessColorDescription: 'Manage access colors to control volunteer event access.',
    emailCampaignsTitle: 'Email Campaigns',
    emailCampaignsDescription: 'Create and send email blasts to volunteers',
    formsTitle: 'Forms',
    formsDescription: 'Create public forms and review submitted responses',
    miTitle: 'Statistics',
    miDescription: 'Summarized insights and analytics',
    internationalRegisterationTitle: 'Non-IIUK Registrations',
    internationalRegisternationDescription: 'Manage Non-IIUK volunteer registrations.',
    allocationStatusTitle: 'Duty Acceptance',
    allocationStatusDescription: 'View and manage volunteer duty acceptance/decline statuses',
    checkInTitle: 'Check-In',
    checkInDescription: 'Scan badges to check volunteers in for their duties',
    eventDayTitle: 'Live Event Operations',
    eventDayDescription: 'Monitor real-time volunteer attendance, shift coverage, and critical operational metrics',
    userLogTitle: "User Log",
    userLogDescription: "Monitor User activity",
    guidelineTitle: "Guidelines",
    guidelineDescription: "Create and manage guideline content",
    JvTitle: "Junior Volunteer Points",
    JVDescription: "Manage points earned by junior volunteers",
    directorVolunteerTitle: "Jamat Khana Volunteers",
    directorVolunteerDescription: "View all volunteers from your jamat khana."
}

export const PublicFormsMeta: PublicFormsMetaProps = {
    title: 'Forms',
    description: 'Create public forms and review responses submitted through shared links',
    backButton: 'Back to Admin Hub',
    createButton: 'Create Form',
    errorTitle: 'Something went wrong',
    noFormsMessage: 'No forms have been created yet.',
    publicUrlLabel: 'Public URL',
    copyLinkButton: 'Copy Link',
    copiedText: 'Copied',
    editButton: 'Edit',
    deleteButton: 'Delete',
    viewResultsButton: 'View Results',
    hideResultsButton: 'Hide Results',
    submissionsTitle: 'Responses',
    noSubmissionsMessage: 'No responses have been submitted yet.',
    submittedAtLabel: 'Submitted',
    activeLabel: 'Active',
    inactiveLabel: 'Inactive',
    submissionsCountLabel: 'responses',
    titleLabel: 'Title',
    slugLabel: 'Custom URL',
    overrideUrlLabel: 'Override URL',
    overrideUrlHelpText: 'Optional. Leave this off to generate a random public link automatically. Turn it on to choose a friendly ending for the URL.',
    customUrlPlaceholder: 'volunteer-interest',
    descriptionLabel: 'Description',
    activeFormLabel: 'Make form live and allow submissions',
    fieldsLabel: 'Fields',
    addFieldButton: 'Add Field',
    fieldLabelLabel: 'Field Label',
    fieldTypeLabel: 'Field Type',
    requiredLabel: 'Required',
    optionsLabel: 'Options',
    optionPlaceholder: 'Option text',
    addOptionButton: 'Add Option',
    removeButton: 'Remove',
    saveButton: 'Save Form',
    savingButton: 'Saving...',
    createModalTitle: 'Create Form',
    editModalTitle: 'Edit Form',
    textTypeLabel: 'Single Line Text',
    emailTypeLabel: 'Email Address',
    checkboxTypeLabel: 'Checkbox Group',
    radioTypeLabel: 'Radio Group',
    selectTypeLabel: 'Dropdown Select',
    deleteTitle: 'Delete Form',
    deleteMessage: 'This will permanently delete the form and all submitted responses.',
    matchByLabel: 'Match volunteers by',
    matchedVolunteerColumn: 'Matched Volunteer',
    matchingLabel: 'Matching...',
    noMatchLabel: 'No match',
    selectMatchButton: (count: number) => `Select (${count})`,
    changeMatchButton: 'Change',
    matchModalTitle: 'Select Matched Volunteer',
    matchModalDescription: 'More than one volunteer matched this email address. Select the correct one.',
    matchIdColumn: 'ID',
    matchNameColumn: 'Name',
    matchEmailColumn: 'Email',
    matchSelectButton: 'Select',
    matchCloseButton: 'Close',
    approveAndAllocateButton: 'Approve & Assign',
    allocateModalTitle: 'Approve and Assign Volunteer',
    allocateEventLabel: 'Event',
    allocateAreaLabel: 'Area',
    allocateShiftLabel: 'Shift',
    allocateSelectEventPlaceholder: 'Select an event',
    allocateSelectAreaPlaceholder: 'Select an area',
    allocateNoShiftsMessage: 'No shifts found for this area.',
    approveAndAllocateConfirmButton: 'Approve & Assign',
    approveAndAllocatingButton: 'Approving...',
    approveAndAllocateSuccessMessage: 'Volunteer approved and assigned successfully.',
    allocateCloseButton: 'Close',
    exportLabel: 'Allow Exports',
    exportResultButton: 'Export Submissions',
    showQrCodeButton: 'Show QR Code',
    qrCodeModalTitle: 'Form QR Code',
    qrCodeModalDescription: 'Scan this code or share the link below to open the public form.',
    downloadPngButton: 'Download PNG',
    qrCodeCloseButton: 'Close'
}

export const PublicFormFillMeta: PublicFormFillMetaProps = {
    loadingText: 'Loading form...',
    errorTitle: 'Unable to load form',
    notFoundMessage: 'This form is not available.',
    requiredLabel: 'Required',
    submitButton: 'Submit',
    submittingText: 'Submitting...',
    successTitle: 'Thank You for Your Submission!',
    successMessage: "Your submission has been received successfully. Thank you for your time and for providing the requested information.",
    selectPlaceholder: 'Select an option'
}

export const AdminSettingsMeta: AdminSettingsMetaProps = {
    title: 'System Settings',
    description: 'Manage system-wide configurations and perform administrative actions',
    globalSettingsTitle: 'Global Settings',
    globalSettingsDescription: 'System-wide flags and configuration options',
    visitAnnouncedTitle: 'Visit Announced',
    visitAnnouncedDescription: 'Toggle whether the visit has been publicly announced. This affects what content is visible to users.',
    internationalSignupsEnabledTitle: 'International Signups Enabled',
    internationalSignupsEnabledDescription: 'Toggle whether international visitors are allowed to sign up. This affects the availability of international visitor login and signup options.',
    showShiftInfoTitle: 'Show Shift Information',
    showShiftInfoDescription: 'Toggle whether shift/duty allocation information is displayed on the home page for volunteers.',
    localModeTitle: 'Local Mode',
    localModeDescription: 'Enable local barcode lookup during check-in. When enabled, barcodes are looked up from the local database instead of the external API.',
    trainingManagementTitle: 'Training Management',
    trainingManagementDescription: 'Bulk operations for managing volunteer trainings',
    assignMandatoryTitle: 'Assign Mandatory Trainings',
    assignMandatoryDescription: 'Automatically assign all mandatory trainings to volunteers who don\'t have them yet',
    assignButton: 'Assign to All Volunteers',
    assigningText: 'Assigning...',
    profileManagementTitle: 'Profile Management',
    profileManagementDescription: 'Bulk operations for managing volunteer profiles',
    clearProfilesTitle: 'Request Profile Updates',
    clearProfilesDescription: 'Clear all profile submission timestamps to require all volunteers to review and resubmit their profiles',
    clearProfilesButton: 'Request All Profiles',
    clearingProfilesText: 'Clearing...'
}

export const HomeMeta: HomeMetaProps = {
    greeting: (userName: string) => `Hi ${userName},`,
    motd: 'Welcome to the Ismaili Volunteers VMS Portal. This platform has been created to help support our volunteers by offering a shared space to access training resources, keep track of learning, and coordinate volunteer responsibilities in a considered way. We appreciate the time, care, and commitment you continue to give through your Khidma (service).',
    travelInfo: 'If you are already planning to travel and would like to volunteer, please register your interest. Volunteering is based on personal arrangements, and all travel, accommodation, visa, and related requirements must be arranged independently.',
    visitAnnouncedProfileTitle: 'Register to Volunteer (Europe Didar (Berlin))',
    visitAnnouncedProfileMessage: 'Please register your interest to volunteer for the upcoming Europe Didar (Berlin).',
    visitAnnouncedCompleteButton: 'Complete Registration',
    profileIncompleteWarningTitle: 'Complete Your Profile',
    profileIncompleteWarningMessage: 'Please complete your profile to access all features.',
    completeProfileButton: 'Complete Profile',
    policyIncompleteWarningTitle: 'Action Required: Review Policies',
    policyIncompleteWarningMessage: (count: number) => `You have ${count} ${count !== 1 ? 'policies' : 'policy'} that require${count === 1 ? 's' : ''} your review and acknowledgment.`,
    reviewPoliciesButton: 'Review Policies',
    volunteerMessagesTitle: 'Volunteer Messages',
    priorityLabel: 'Priority',
    viewButton: 'View',
    previousButton: 'Previous',
    nextButton: 'Next',
    pageLabel: 'Page',
    assignedTrainingsTitle: 'Assigned Training',
    noIncompleteTrainingsMessage: 'All assigned training completed!',
    incompleteTrainingsMessage: (count: number) => `You have ${count} incomplete training${count !== 1 ? 's' : ''}.`,
    viewTrainingsButton: 'View My Training',
    assignedShiftsTitle: 'Assigned Duties',
    noAssignedShiftsMessage: 'You have no assigned duties at this time.',
    acceptButton: 'Accept',
    declineButton: 'Decline',
    pendingLabel: 'Pending',
    acceptedLabel: 'Accepted',
    declinedLabel: 'Declined',
    loadingShiftsText: 'Loading your shifts...',
    shiftTimeLabel: 'Shift Time',
    eventLabel: 'Event',
    areaLabel: 'Area',
    shiftLabel: 'Shift',
    shiftLeadLabel: 'Lead',
    declineHelperText: 'Selecting Decline lets us know you\'re unavailable for this duty. Thank you for helping us plan ahead.',
    dutiesNotYetAssignedMessage: 'Duties will be assigned in due course. Please check back regularly for updates.',
    // Accept/Decline modal
    acceptThankYouMessage: 'Thank you for accepting your seva.',
    confirmAcceptMessage: 'Please confirm that you would like to accept this seva.',
    tknCheckboxLabel: 'I would like to offer this duty as part of TKN. Only check this box if you offered a TKN Niyat in 2008 and/or 2018.',
    ivTieScarfLabel: 'For serving during Didar, the IV Tie/Scarf is required. Do you currently have one?',
    ivTieScarfYes: 'Yes',
    ivTieScarfNo: 'No',
    confirmButton: 'Confirm',
    goBackButton: 'Go Back',
    declineModalTitle: 'Decline Duty',
    declineReasonLabel: 'Reason for declining',
    declineReasonPlaceholder: 'Please select a reason',
    declineDetailsLabel: 'Additional details (optional)',
    declineDetailsPlaceholder: 'Please provide any additional information...',
    declineReasons: [
        'Timing is not suitable (another shift may be offered, subject to availability)',
        'I do not wish to undertake this particular duty (another shift may be offered, subject to availability)',
        'Unable to commit at this time (I will visit the VRC on the day)',
        'I no longer wish to continue due to personal reasons'
    ],
    submitDeclineButton: 'Submit',
    cancelButton: 'Cancel',
    startTimeLabel: 'Start Time',
    endTimeLabel: 'End TIme'
}

export const EventsMeta: EventsMetaProps = {
    title: 'Events',
    description: 'Browse and manage all upcoming events',
    errorTitle: 'Error Loading Events',
    noEventsMessage: 'No events found',
    noFilteredEventsMessage: 'No events match the current filter',
    filterLabel: 'Quick filter',
    filterPlaceholder: 'Search events by name...',
    filterPresetsLabel: 'Presets',
    clearFilterButton: 'Clear',
    createButton: 'Create New Event'
}
export const VolunteersMeta: VolunteersMetaProps = {
    title: 'Volunteers',
    description: 'Browse and manage all Volunteers',
    errorTitle: 'Error Loading Volunteer',
    noEventsMessage: 'No Volunteer found',
    createButton: 'Create New Volunteer'
}
export const DutyMeta: DutyMetaProps = {
    title: 'Available Duties',
    description: 'Browse and manage all available duties',
    errorTitle: 'Error Loading Duties',
    noDutyMessage: 'No Duties found',
    dutySearchPlaceHolder: 'Search duty by title...',
    createButton: 'Create New Duty'
}

export const LoadingSpinnerMeta: LoadingSpinnerMetaProps = {
    loadingText: 'Loading...'
}

export const LoginMeta: LoginMetaProps = {
    ukResidentLoginButton: 'Login via IIUK',
    internationalVisitorLoginButton: 'Volunteer Community (non-IIUK registered)',
    checkInLoginLink: 'Check-in login',
    helpText: () => <>{`To access the VMS, please sign in using your IIUK login details.

If you are not yet registered on IIUK, or are unable to access your account, please use the “Forgot Password” option to regain access to IIUK first. Once your IIUK access is restored, you will be able to log in to the VMS.

If you continue to experience any issues with logging in, or if you have any queries, please contact us at`} <a href="mailto:ivc@iiuk.org" className='underline text-primary-600'>ivc@iiuk.org</a>.</>,
    pendingApprovalTitle: 'Account Pending Approval'
}

export const EventCardMeta: EventCardMetaProps = {
    dateLabel: 'Date',
    timeLabel: 'Time',
    locationLabel: 'Location',
    areasLabel: 'Areas',
    addressLabel: 'Address',
    areasSingular: 'area',
    areasPlural: 'areas',
    viewDetailsButton: 'View Details',
    visibleLabel: 'Visible',
    perAreaLabel: 'Per-Area',
    shiftsVisibleTooltip: 'Approved shifts in this event are visible to volunteers (event-level visibility enabled)',
    shiftsPerAreaTooltip: 'Shift visibility is controlled at the area level - check individual areas'
}
export const VolunteerCardMeta: VolunteerCardMetaProps = {
    dateLabel: 'Date',
    timeLabel: 'Time',
    locationLabel: 'Location',
    areasLabel: 'Areas',
    addressLabel: 'Address',
    areasSingular: 'area',
    areasPlural: 'areas',
    viewDetailsButton: 'View Details'
}
export const DutyCardMeta: DutyCardMetaProps = {
    'nameLabel': 'Duty Name'
}

export const PreferenceMeta: PreferenceMetaProps = {
    title: 'Available Preferences',
    description: 'Browse and manage all volunteer preferences',
    errorTitle: 'Error Loading Preferences',
    noPreferenceMessage: 'No Preferences found',
    preferenceSearchPlaceHolder: 'Search preference by name or category...',
    createButton: 'Create New Preference'
}

export const PreferenceCardMeta: PreferenceCardMetaProps = {
    nameLabel: 'Preference Name',
    categoryLabel: 'Category',
    descriptionLabel: 'Description'
}

export const EventDetailMeta: EventDetailMetaProps = {
    backToEventsButton: 'Back to Events',
    areasTitle: 'Areas',
    noAreasMessage: 'No areas found for this event',
    shiftsTitle: 'Shifts',
    noShiftsMessage: 'No shifts assigned to this area',
    loadingText: 'Loading...',
    errorTitle: 'Error',
    dateLabel: 'Date',
    timeLabel: 'Time',
    startTimeLabel: 'Start Time',
    endTimeLabel: 'End Time',
    capacityLabel: 'Capacity',
    volunteersLabel: 'Volunteers',
    maxVolunteersLabel: 'Max Volunteers',
    descriptionLabel: 'Description',
    locationLabel: 'Location',
    addressLabel: 'Address',
    showShiftsButton: 'Show Shifts',
    hideShiftsButton: 'Hide Shifts',
    leadsTitle: "Event Leads",
    leadNameTitle: "Lead Name",
    deputyLeadNameTitle: "Deputy Lead",
    contactTitle: "Contact",
    editEventButton: 'Edit Event',
    copyShiftAllocationsButton: 'Copy allocations',
    exportShiftRegionStatusButton: 'Export Shift Status',
    exportingShiftRegionStatusButton: 'Exporting...',
    exportShiftRegionStatusError: 'Failed to export shift status data',
    selectEmailCampaignsTitle: 'Select Email Campaigns',
    selectEmailCampaignsDescription: 'Choose which sent email campaigns should count for the Email Sent Y/N columns in this export.',
    selectEmailCampaignsCancelButton: 'Cancel',
    selectEmailCampaignsExportButton: 'Export Selected Campaigns',
    selectEmailCampaignsError: 'Please select at least one email campaign to count for this export.',
    emailCampaignLoadError: 'Failed to load email campaigns',
    noEmailCampaignsMessage: 'No email campaigns are available to select.',
    emailCampaignOptionDetails: (status, sentCount, createdAt) => `${status.replace('_', ' ')} • ${sentCount} sent • Created ${new Date(createdAt).toLocaleDateString()}`,
    createAreaButton: 'Create New Area',
    addShiftButton: 'Add Shift',
    required_volunteer_count_label: 'Required Volunteers',
    allocation_count_label: "Volunteers Allocated",
    leads_count_label: "Lead Positions",
    multi_allocation_count_label: "With Multiple Assignments",
    accepted_allocations_label: 'Accepted',
    rejected_allocations_label: 'Rejected',
    pending_allocations_label: 'Pending',
    visibleLabel: 'Visible',
    visibleViaEventLabel: 'Visible via Event',
    hiddenLabel: 'Hidden',
    shiftsVisibleTooltip: 'Approved shifts in this area are visible to volunteers (area-level visibility enabled)',
    shiftsVisibleViaEventTooltip: 'Approved shifts in this area are visible to volunteers (via event-level visibility)',
    shiftsHiddenTooltip: 'Shifts in this area are hidden from volunteers (enable visibility at area or event level)'
}

export const EventFormModalMeta: EventFormModalMetaProps = {
    title: 'Create New Event',
    nameLabel: 'Event Name',
    namePlaceholder: 'Enter event name',
    organizerLabel: 'Organizer',
    organizerPlaceholder: 'Enter organizer name',
    startDateLabel: 'Start Date',
    endDateLabel: 'End Date',
    startTimeLabel: 'Start Time',
    endTimeLabel: 'End Time',
    locationLabel: 'Location',
    locationPlaceholder: 'Enter venue name',
    addressLabel: 'Address',
    addressPlaceholder: 'Enter full address',
    cityLabel: 'City',
    cityPlaceholder: 'Enter city',
    countryLabel: 'Country',
    countryPlaceholder: 'Enter country',
    submitButton: 'Create Event',
    submittingButton: 'Creating...',
    cancelButton: 'Cancel',
    closeButton: 'Close',
    errorMessage: 'Failed to create event. Please try again.',
    leadNamePlaceholder: 'Lead Name',
    leadPhoneNumberPlaceHolder: 'Lead Phone Number',
    deputyLeadNamePlaceHolder: 'Deputy Lead Name',
    deputyLeadPhoneNumberPlaceHolder: 'Deputy Lead Phone Number',
    leadNameTitle: 'Lead Details',
    leadcontactTitle: 'Lead Phone Number',
    deputyLeadNameTitle: 'Deputy Lead Details',
    deputyLeadcontactTitle: 'Deputy Lead Phone Number',
    required_volunteer_count_title: 'Required Volunteer Count',
    require_walkie_talkie_label: 'Require Walkie Talkie',
    shiftsVisibleLabel: 'Shifts Visible to Volunteers',
    shiftsVisibleDescription: 'When enabled, approved shifts in this event will be visible to volunteers for acceptance/decline. Shifts must also be approved (locked) to be visible.',
    includeInDuplicateChecksLabel: 'Include in Duplicate Checks',
    includeInDuplicateChecksDescription: 'When enabled, allocations in this event will count towards volunteer duplicate checks. Disable for events that should not affect duplicate counting.',
}

export const DuplicateEventModalMeta: DuplicateEventModalMetaProps = {
    title: 'Duplicate Event',
    nameLabel: 'Event Name',
    namePlaceholder: 'Enter event name',
    startDateLabel: 'Start Date',
    endDateLabel: 'End Date',
    startTimeLabel: 'Start Time',
    endTimeLabel: 'End Time',
    submitButton: 'Duplicate Event',
    submittingButton: 'Duplicating...',
    cancelButton: 'Cancel',
    errorMessage: 'Failed to duplicate event. Please try again.',
    description: 'This will create a copy of the event including all areas and shifts, but not volunteer allocations. You can modify the name and dates for the new event.'
}

export const VolunteerFormModalMeta: VolunteerFormModalMetaProps = {
    title: 'Volunteer Information',
    nameLabel: 'First Name',
    namePlaceholder: 'Enter first name',
    lastNameLabel: 'Last Name',
    lastNamePlaceholder: 'Enter last name',
    secondLastNameLabel: 'Second Last Name',
    secondLastNamePlaceholder: 'Enter second last name (optional)',
    genderLabel: 'Gender',
    dobLabel: 'Date of Birth',
    contactLabel: 'Phone Number',
    contactPlaceholder: 'Enter phone number',
    countryCodeLabel: 'Country Code',
    EmailLabel: 'Email',
    EmailPlaceholder: 'Enter email address',
    CountryofResidence: 'Country of Residence',
    countryOfBirthLabel: 'Country of Birth',
    Jamatkhana: 'Jamatkhana',
    FamilyOriginLabel: 'Family Origin',
    serviceLocationLabel: 'Service Location',
    serviceRecordLabel: 'Please let us know if you like to serve as Uniform Volunteer or Non-Uniformed Volunteer',
    languagesLabel: 'Languages',
    supportNeedsLabel: 'Special Support Needs',
    supportNeedsPlaceholder: 'Please let us know if you need any special assistance',
    volunteerStatusLabel: 'Volunteer Status',
    ismailiLabel: 'Ismaili',
    multiFaithFamilyLabel: 'Inter-Faith Family',
    registeredVolunteerLabel: 'Registered Volunteer',
    eligibleForDutyLabel: 'Eligible for Duty',
    preferencesLabel: 'Preferences',
    flagsLabel: 'Volunteer Additional Details',
    submitButton: 'Submit',
    submittingButton: 'Submitting...',
    cancelButton: 'Cancel',
    closeButton: 'Close',
    errorMessage: 'Failed to submit profile. Please try again.',
    volunteerForVisit: 'Would you like to volunteer during Didar?',
    availabilityLabel: 'Please indicate how you would like to help (you may select multiple options):',
    negativeListLabel: "Cannot perform duties",
    registrationNote: () => <>
        Please ensure that you have registered for Europe Didar (Berlin) (if eligible) via <Link to={`${IIUK_BASE_URL}`} className='font-medium underline inline-block break-inside-avoid' target='_blank'>IIUK <ExternalLinkIcon className='inline w-3.5 h-3.5' /></Link> or The Ismaili App.<br />
        This registration is <i>only</i> for volunteer management and does <i>not</i> constitute registration for Europe Didar (Berlin) itself.
    </>,
    registrationAckLabel: 'I understand',
    successMessage: 'Your volunteer profile has been submitted successfully.',
}

export const DutyFormModalMeta: DutyFormModalMetaProps = {
    title: 'Create New Duty',
    nameLabel: 'Name',
    negativeListMemberLabel: 'Include in Negative List',
    namePlaceholder: 'Enter duty name',
    submitButton: 'Create Duty',
    submittingButton: 'Creating...',
    cancelButton: 'Cancel',
    closeButton: 'Close',
    errorMessage: 'Failed to create duty. Please try again.'
}

export const PreferenceFormModalMeta: PreferenceFormModalMetaProps = {
    title: 'Create New Preference',
    nameLabel: 'Name',
    namePlaceholder: 'Enter Preference Name',
    categoryLabel: 'Category',
    categoryPlaceholder: 'Enter Category',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Enter Description',
    submitButton: 'Create Preference',
    submittingButton: 'Creating...',
    cancelButton: 'Cancel',
    closeButton: 'Close',
    errorMessage: 'Failed to create preference. Please try again.'
}

export const DeleteDutyMeta: DeleteDutyMetaProps = {
    deleteButtonText: 'Delete Duty',
    confirmTitle: 'Delete Duty',
    confirmMessage: 'Are you sure you want to delete this duty? This action cannot be undone and will remove the selected duty.'
}

export const DeletePreferenceMeta: DeletePreferenceMetaProps = {
    deleteButtonText: 'Delete Preference',
    confirmTitle: 'Delete Preference',
    confirmMessage: 'Are you sure you want to delete this preference? This action cannot be undone and will remove the selected preference.'
}

export const FlagMeta: FlagMetaProps = {
    title: 'Available Flags',
    description: 'Browse and manage all volunteer flags',
    errorTitle: 'Error Loading Flags',
    noFlagMessage: 'No Flags found',
    flagSearchPlaceHolder: 'Search flag by name...',
    createButton: 'Create New Flag',
    categorySectionTitle: 'Flag Categories',
    noCategoryMessage: 'No categories found',
    createCategoryButton: 'Create New Category'
}

export const CoreTeamMeta: CoreTeamMetaProps = {
    title: 'Core Team',
    description: 'View and manage core team members across all streams',
    createButton: 'Add Core Team Member',
    errorTitle: 'Error Loading Core Team',
    noDataMessage: 'No core team members found',
    loadingText: 'Loading core team members...'
}

export const CoreTeamStatsMeta: CoreTeamStatsMetaProps = {
    statsTitle: 'Statistics',
    showStatsButton: 'Show Statistics',
    hideStatsButton: 'Hide Statistics',
    genderTitle: 'Gender',
    regionTitle: 'Region',
    familyOriginTitle: 'Family Origin',
    londonLabel: 'London',
    notLondonLabel: 'Not London',
    excludedReservedNote: '(Reserved tier excluded)',
    otherLabel: 'Other'
}

export const CoreTeamTableMeta: CoreTeamTableMetaProps = {
    idColumn: 'ID',
    nameColumn: 'Name',
    streamsColumn: 'Streams',
    roleColumn: 'Role',
    tierColumn: 'Tier',
    phoneColumn: 'Phone',
    emailColumn: 'Email',
    ismailiColumn: 'Ismaili',
    familyOriginColumn: 'Family Origin',
    ageBandColumn: 'Age Band',
    notesColumn: 'Notes',
    duplicationsColumn: 'Duplications',
    submittedByColumn: 'Submitted By',
    statusColumn: 'Approval Status',
    activityStatusColumn: 'Activity Status',
    actionsColumn: 'Actions',
    approvedStatus: 'Approved',
    pendingStatus: 'Submitted',
    activeStatus: 'Active',
    onHoldStatus: 'On Hold',
    approveButton: 'Approve',
    rejectButton: 'Reject',
    yesLabel: 'Yes',
    noLabel: 'No',
    viewAllocationsButton: (count: number) => `View duplications (${count})`,
    streamFilterLabel: 'Stream',
    allStreamsLabel: 'All Streams',
    tierFilterLabel: 'Tier',
    allTiersLabel: 'All Tiers',
    statusFilterLabel: 'Approval Status',
    allStatusLabel: 'All Status',
    activityStatusFilterLabel: 'Activity Status',
    allActivityStatusLabel: 'All',
    duplicationsFilterLabel: 'Duplications',
    anyDuplicationsLabel: 'Any',
    hasDuplicationsLabel: 'Has Duplications',
    noDuplicationsLabel: 'No Duplications',
    putOnHoldButton: 'Put On Hold',
    makeActiveButton: 'Make Active',
    selectedCountLabel: (count: number) => `${count} selected`,
    clearSelectionLabel: 'Clear selection',
    bulkApproveLabel: 'Approve',
    bulkApprovingLabel: 'Approving...',
    bulkRejectLabel: 'Reject',
    bulkRejectingLabel: 'Rejecting...',
    bulkUnapproveLabel: 'Unapprove',
    bulkUnapprovingLabel: 'Unapproving...',
    bulkDeleteLabel: 'Delete',
    bulkDeletingLabel: 'Deleting...',
    bulkPutOnHoldLabel: 'Put On Hold',
    bulkPuttingOnHoldLabel: 'Putting On Hold...',
    bulkMakeActiveLabel: 'Make Active',
    bulkMakingActiveLabel: 'Making Active...',
    previousPageLabel: 'Previous',
    nextPageLabel: 'Next',
    pageInfoLabel: (start: number, end: number, total: number) => `Showing ${start}-${end} of ${total}`,
    rowsPerPageLabel: 'Rows per page',
    exportButton: 'Export to CSV'
}

export const RejectedCoreTeamTableMeta: RejectedCoreTeamTableMetaProps = {
    title: 'Rejected Core Team Entries',
    nameColumn: 'Name',
    streamsColumn: 'Streams',
    roleColumn: 'Role',
    tierColumn: 'Tier',
    rejectedByColumn: 'Rejected By',
    rejectedDateColumn: 'Rejected Date',
    deleteButton: 'Delete',
    deletingButton: 'Deleting...',
    noDataMessage: 'No rejected entries found',
    searchPlaceholder: 'Search rejected entries...',
    clearFiltersButton: 'Clear',
    exportButton: 'Export to CSV'
}

export const CoreTeamFormModalMeta: CoreTeamFormModalMetaProps = {
    title: 'Add Core Team Member',
    volunteerLabel: 'Volunteer',
    submittedByLabel: 'Submitted By',
    streamsLabel: 'Streams',
    streamsSelectedLabel: 'stream(s) selected',
    streamsRequiredError: 'Please select at least one stream',
    statusLabel: 'Activity Status',
    activeStatus: 'Active',
    onHoldStatus: 'On Hold',
    roleLabel: 'Role',
    rolePlaceholder: 'Enter role (e.g., ExCo, PMO)',
    roleRequiredError: 'Role is required',
    tierLabel: 'Tier',
    tierRequiredError: 'Tier is required',
    notesLabel: 'Notes (optional)',
    notesPlaceholder: 'Enter any additional notes',
    submitButton: 'Submit for Approval',
    submittingButton: 'Submitting...',
    cancelButton: 'Cancel',
    errorMessage: 'Failed to add core team member. Please try again.'
}

export const CoreTeamAddModalMeta: CoreTeamAddModalMetaProps = {
    title: 'Select Volunteer to Add',
    nameSearchPlaceholder: 'Search by name...',
    emailSearchPlaceholder: 'Search by email...',
    phoneSearchPlaceholder: 'Search by phone...',
    idSearchPlaceholder: 'Search by ID...',
    searchButton: 'Search',
    clearButton: 'Clear',
    loadingText: 'Loading volunteers...',
    pagesLabel: 'pages',
    showingLabel: 'Showing',
    volunteersLabel: 'volunteers',
    noResultsMessage: 'No volunteers found matching your search',
    noVolunteersMessage: 'All volunteers are already in the core team',
    idColumn: 'ID',
    nameColumn: 'Name',
    phoneColumn: 'Phone',
    emailColumn: 'Email',
    jamatKhanaColumn: 'Jamatkhana',
    duplicationsColumn: 'Duplications',
    viewDuplicationsButton: (count: number) => `View (${count})`,
    actionColumn: 'Action',
    addButton: 'Add',
    closeButton: 'Close',
    errorMessage: 'Failed to load volunteers. Please try again.',
    duplicationsModalTitle: (firstName: string, lastName: string) => `Duplications for ${firstName} ${lastName}`,
    shiftAllocationsTitle: (count: number) => `Shift Allocations (${count})`,
    excludedAllocationsTitle: (count: number) => `Excluded from Duplicate Count (${count})`,
    excludedAllocationsDescription: 'These allocations are from events not included in duplicate checks.',
    coreTeamAssignmentsTitle: (count: number) => `Core Team Assignments (${count})`,
    leadPositionsTitle: (count: number) => `Lead/Deputy Lead Positions (${count})`,
    excludedLeadPositionsTitle: (count: number) => `Excluded Lead Positions (${count})`,
    excludedLeadPositionsDescription: 'These lead positions are from events not included in duplicate checks.',
    positionTypeColumn: 'Type',
    statusColumn: 'Status',
    eventColumn: 'Event',
    areaColumn: 'Area',
    shiftColumn: 'Shift',
    dateTimeColumn: 'Date/Time',
    noDuplicationsMessage: 'No other allocations or core team assignments found.',
    closeModalButton: 'Close',
    submittedStatus: 'Submitted',
    approvedStatus: 'Approved',
    pendingStatus: 'Pending',
    acceptedStatus: 'Accepted',
    declinedStatus: 'Declined',
    roleColumn: 'Role',
    streamsColumn: 'Streams'
}

export const FlagCardMeta: FlagCardMetaProps = {
    nameLabel: 'Flag Name',
    descriptionLabel: 'Description',
    hiddenFromRegistrationLabel: 'Hidden from registration'
}

export const FlagFormModalMeta: FlagFormModalMetaProps = {
    title: 'Create New Flag',
    nameLabel: 'Name',
    categoryLabel: 'Category',
    categoryPlaceholder: 'Select a category (optional)',
    noCategoryOption: 'No Category',
    namePlaceholder: 'Enter flag name (e.g., Fire Safety Trained, Medical Professional)',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Enter flag description',
    hasExpiryLabel: 'Has Expiry Date',
    hiddenFromRegistrationLabel: 'Hide from registration form',
    submitButton: 'Create Flag',
    submittingButton: 'Creating...',
    cancelButton: 'Cancel',
    closeButton: 'Close',
    errorMessage: 'Failed to create flag. Please try again.'
}

export const UpdateFlagFormMeta: UpdateFlagFormMetaProps = {
    title: 'Update Flag',
    submitButton: 'Update Flag',
    submittingButton: 'Updating...'
}

export const DeleteFlagMeta: DeleteFlagMetaProps = {
    deleteButtonText: 'Delete Flag',
    confirmTitle: 'Delete Flag',
    confirmMessage: 'Are you sure you want to delete this flag? This action cannot be undone and will remove the selected flag.'
}

export const FlagCategoryFormModalMeta: FlagCategoryFormModalMetaProps = {
    title: 'Create New Category',
    nameLabel: 'Category Name',
    namePlaceholder: 'Enter category name',
    submitButton: 'Create Category',
    submittingButton: 'Creating...',
    cancelButton: 'Cancel',
    errorMessage: 'Failed to create category. Please try again.'
}

export const UpdateFlagCategoryFormMeta: UpdateFlagCategoryFormMetaProps = {
    title: 'Update Category',
    submitButton: 'Update Category',
    submittingButton: 'Updating...'
}

export const DeleteFlagCategoryMeta: DeleteFlagCategoryMetaProps = {
    deleteButtonText: 'Delete',
    confirmTitle: 'Delete Category',
    confirmMessage: 'Are you sure you want to delete this category? Flags in this category will not be deleted, but will have no category assigned.'
}

export const ConfirmationModalMeta: ConfirmationModalMetaProps = {
    confirmButton: 'Delete',
    cancelButton: 'Cancel',
    deletingButton: 'Deleting...'
}

export const DeleteEventMeta: DeleteEventMetaProps = {
    deleteButtonText: 'Delete Event',
    confirmTitle: 'Delete Event',
    confirmMessage: 'Are you sure you want to delete this event? This action cannot be undone and will remove all associated areas, shifts, and allocations.',
    detailDeleteButtonText: 'Delete Event'
}

export const UpdateEventFormMeta: UpdateEventFormMetaProps = {
    title: 'Edit Event',
    submitButton: 'Update Event',
    submittingButton: 'Updating...'
}

export const UpdateDutyFormMeta: UpdateDutyFormMetaProps = {
    title: 'Edit Duty',
    submitButton: 'Update Duty',
    submittingButton: 'Updating...'
}

export const UpdatePreferenceFormMeta: UpdatePreferenceFormMetaProps = {
    title: 'Edit Preference',
    submitButton: 'Update Preference',
    submittingButton: 'Updating...'
}

export const AreaFormModalMeta: AreaFormModalMetaProps = {
    title: 'Create New Area',
    nameLabel: 'Area Name',
    namePlaceholder: 'Enter area name',
    submitButton: 'Create Area',
    submittingButton: 'Creating...',
    cancelButton: 'Cancel',
    closeButton: 'Close',
    errorMessage: 'Failed to create area. Please try again.',
    leadNameTitle: 'Lead Name',
    leadcontactTitle: 'Lead Phone Number',
    deputyLeadNameTitle: 'Deputy Lead Name',
    deputyLeadcontactTitle: 'Deputy Lead Phone Number',
    leadNamePlaceholder: 'Enter Lead Name',
    leadPhoneNumberPlaceHolder: 'Enter Lead Phone Number',
    deputyLeadNamePlaceHolder: 'Enter Deputy Lead Name',
    deputyLeadPhoneNumberPlaceHolder: 'Enter Deputy Lead Phone Number',
    required_volunteer_count_title: 'Required Volunteer Count',
    accessColorLabel: 'Access Color',
    require_walkie_talkie_label: 'Require Walkie Talkie',
    shiftsVisibleLabel: 'Shifts Visible to Volunteers',
    shiftsVisibleDescription: 'When enabled, approved shifts in this area will be visible to volunteers for acceptance/decline. Shifts must also be approved (locked) to be visible.',
}

export const UpdateAreaFormMeta: UpdateAreaFormMetaProps = {
    title: 'Edit Area',
    submitButton: 'Update Area',
    submittingButton: 'Updating...'
}

export const DeleteAreaMeta: DeleteAreaMetaProps = {
    deleteButtonText: 'Delete Area',
    confirmTitle: 'Delete Area',
    confirmMessage: 'Are you sure you want to delete this area? This action cannot be undone and will remove all associated shifts and allocations.'
}

export const ShiftFormModalMeta: ShiftFormModalMetaProps = {
    title: 'Create New Shift',
    dutyLabel: 'Duty Type',
    dutyPlaceholder: 'Select a duty type',
    startTimeLabel: 'Start Time',
    endTimeLabel: 'End Time',
    submitButton: 'Create Shift',
    submittingButton: 'Creating...',
    cancelButton: 'Cancel',
    closeButton: 'Close',
    errorMessage: 'Failed to create shift. Please try again.',
    leadNameTitle: 'Lead Name',
    leadcontactTitle: 'Lead Phone Number',
    deputyLeadNameTitle: 'Deputy Lead Name',
    deputyLeadcontactTitle: 'Deputy Lead Phone Number',
    leadNamePlaceholder: 'Enter Lead Name',
    leadPhoneNumberPlaceHolder: 'Enter Lead Phone Number',
    deputyLeadNamePlaceHolder: 'Enter Deputy Lead Name',
    deputyLeadPhoneNumberPlaceHolder: 'Enter Deputy Lead Phone Number',
    required_volunteer_count_lable: 'Required Volunteer Count',
    accessColorLabel: 'Access Color',
    require_walkie_talkie_label: 'Require Walkie Talkie',
    criteriaLabel: 'Criteria (Optional)',
    criteriaPlaceHolder: 'Enter detailed criteria or notes...',
    titleLabel: 'Title',
    titlePlaceHolder: 'Enter shift title...',
    instructionLabel: 'Instructions (Optional)',
    instructionPlaceHolder: 'Enter your instructions here...'
}

export const UpdateShiftFormMeta: UpdateShiftFormMetaProps = {
    title: 'Edit Shift',
    submitButton: 'Update Shift',
    submittingButton: 'Updating...'
}

export const DuplicateShiftModalMeta: DuplicateShiftModalMetaProps = {
    title: 'Duplicate Shift',
    description: 'Create copies of this shift. You can choose to include or exclude volunteer allocations, and duplicate to the same area or a different event/area.',
    countLabel: 'Number of Copies',
    countPlaceholder: 'Enter number (1-50)',
    countValidationError: 'Count must be between 1 and 50',
    includeAllocationsLabel: 'Include volunteer allocations',
    includeAllocationsDescription: 'If checked, all current volunteer allocations will be copied to the new shift(s).',
    destinationLabel: 'Destination',
    sameAreaLabel: 'Same area',
    differentAreaLabel: 'Different event/area',
    eventLabel: 'Event',
    selectEventPlaceholder: 'Select an event',
    areaLabel: 'Area',
    selectAreaPlaceholder: 'Select an area',
    selectAreaError: 'Please select an area for the duplicated shift(s)',
    submitButton: 'Duplicate',
    submittingButton: 'Duplicating...',
    cancelButton: 'Cancel',
    errorMessage: 'Failed to duplicate shift. Please try again.'
}

export const CopyShiftAllocationsModalMeta: CopyShiftAllocationsModalMetaProps = {
    title: 'Copy Shift Allocations',
    description: 'Copy the volunteers allocated to this shift into another shift. The destination shift times will be used and copied allocations will start as pending.',
    sourceShiftLabel: 'Source shift',
    eventLabel: 'Event',
    selectEventPlaceholder: 'Select an event',
    areaLabel: 'Area',
    selectAreaPlaceholder: 'Select an area',
    shiftLabel: 'Shift',
    selectShiftPlaceholder: 'Select a shift',
    selectShiftError: 'Please select a destination shift',
    noTargetShiftsMessage: 'No other shifts available in this area',
    loadEventsError: 'Failed to load events',
    submitButton: 'Copy Allocations',
    submittingButton: 'Copying...',
    cancelButton: 'Cancel',
    errorMessage: 'Failed to copy shift allocations. Please try again.'
}

export const DuplicateAreaModalMeta: DuplicateAreaModalMetaProps = {
    title: 'Duplicate Area',
    description: 'Create copies of this area and all of its shifts. You can choose to include or exclude volunteer allocations, and duplicate to the same event or a different event.',
    countLabel: 'Number of Copies',
    countPlaceholder: 'Enter number (1-50)',
    countValidationError: 'Count must be between 1 and 50',
    includeAllocationsLabel: 'Include volunteer allocations',
    includeAllocationsDescription: 'If checked, all current shift allocations in this area will be copied to the new area(s).',
    destinationLabel: 'Destination',
    sameEventLabel: 'Same event',
    differentEventLabel: 'Different event',
    eventLabel: 'Event',
    selectEventPlaceholder: 'Select an event',
    selectEventError: 'Please select an event for the duplicated area(s)',
    loadEventsError: 'Failed to load events',
    submitButton: 'Duplicate',
    submittingButton: 'Duplicating...',
    cancelButton: 'Cancel',
    errorMessage: 'Failed to duplicate area. Please try again.'
}

export const DeleteShiftMeta: DeleteShiftMetaProps = {
    confirmTitle: 'Delete Shift',
    confirmMessage: 'Are you sure you want to delete this shift? This action cannot be undone and will remove all associated allocations.'
}

export const TrainingListMeta: TrainingListMetaProps = {
    assignedTitle: 'My Assigned Training',
    availableTitle: 'Other Available Training',
    errorTitle: 'Error Loading Training',
    noAssignedTrainingsMessage: 'You have no assigned training at this time.',
    noAvailableTrainingsMessage: 'No other training is available.',
    loadingText: 'Loading training...',
    modulesLabel: 'modules',
    durationLabel: 'Duration',
    minutesSuffix: 'min',
    mandatoryBadge: 'MANDATORY'
}

export const AdminTrainingsMeta: AdminTrainingsMetaProps = {
    title: 'Manage Trainings',
    description: 'Create, edit, and manage training modules for volunteers',
    errorTitle: 'Error Loading Trainings',
    noTrainingsMessage: 'No trainings available. Click "Create New Training" to add one.',
    loadingText: 'Loading trainings...',
    assignVolunteersMessage: 'Assign to Volunteers'
}

export const TrainingFormModalMeta: TrainingFormModalMetaProps = {
    title: 'Create New Training',
    nameLabel: 'Training Name',
    namePlaceholder: 'Enter training name',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Enter training description',
    mandatoryLabel: 'Mandatory Training',
    policyLabel: 'Policy (only shown on homepage when incomplete)',
    modulesLabel: 'Training Modules',
    addModuleButton: 'Add Module',
    removeModuleButton: 'Remove',
    moduleTypeLabel: 'Module Type',
    moduleTitleLabel: 'Module Title',
    moduleTitlePlaceholder: 'Enter module title',
    moduleUrlLabel: 'URL',
    moduleUrlPlaceholder: 'https://example.com/resource',
    moduleFileLabel: 'File',
    moduleFilePlaceholder: 'No file selected',
    moduleFileUploadButton: 'Upload File',
    moduleFileUploadingButton: 'Uploading...',
    moduleFileRemoveButton: 'Remove File',
    moduleContentTypeLabel: 'Content Type',
    moduleContentTypeUrl: 'URL',
    moduleContentTypeFile: 'File Upload',
    moduleContentTypeLibrary: 'Library',
    browseLibraryButton: 'Browse Library',
    libraryBrowserTitle: 'Select Video from Library',
    libraryBrowserSelectButton: 'Select Video',
    libraryBrowserCancelButton: 'Cancel',
    libraryBrowserLoadingText: 'Loading videos...',
    libraryBrowserErrorText: 'Failed to load videos. Please try again.',
    libraryBrowserNoVideosText: 'No videos in library yet.',
    moduleDescriptionLabel: 'Description (Optional)',
    moduleDescriptionPlaceholder: 'Enter module description',
    moduleDurationLabel: 'Duration (minutes)',
    moduleDurationPlaceholder: '15',
    moduleOrderPlaceholder: '0',
    moduleRequiredLabel: 'Required',
    noModulesMessage: 'No modules added yet. Click "Add Module" to create your first module.',
    submitButton: 'Create Training',
    submittingButton: 'Creating...',
    cancelButton: 'Cancel',
    closeButton: 'Close',
    errorMessage: 'Failed to create training. Please try again.',
    questionsLabel: 'Training Questions',
    addQuestionButton: 'Add Question',
    noQuestionMessage: 'No Questions added yet. Click "Add Question" to create your first queestion.',
    questionLable: 'Question',
    questionPlaceHolder: 'Enter Question Here',
    answerDescriptionLabel: 'Answer Description (Optional)',
    answerDescriptionPlaceholder: 'Provide additional context or explanation for this question',
    optionLabel: 'Option',
    addOptionButton: 'Add Option',
    noOptionMessage: 'No options added yet.  Click "Add Option" to create your first option.',
    optionPlaceHolder: 'Enter Option Here',
    optionsLabel: 'Options',
    optionSelectionMessage: 'Please select the option which is the answer.',
    noOptionsDisplayMessage: 'No Options are available for this question.'
}

export const UpdateTrainingFormMeta: UpdateTrainingFormMetaProps = {
    title: 'Edit Training',
    submitButton: 'Update Training',
    submittingButton: 'Updating...'
}

export const DocumentViewerMeta: DocumentViewerMetaProps = {
    loadingText: 'Loading document...',
    errorTitle: 'Error Loading Document',
    errorInvalidUrl: 'Invalid document URL provided.',
    errorLoadingDocument: 'Failed to load the document. Please try again.'
}

export const VideoPlayerMeta: VideoPlayerMetaProps = {
    loadingText: 'Loading video...',
    errorTitle: 'Error Loading Video',
    errorInvalidUrl: 'Invalid video URL provided.',
    errorLoadingVideo: 'Failed to load the video. Please try again.',
    muteLabel: 'Mute',
    unmuteLabel: 'Unmute',
    enterFullscreenLabel: 'Enter Fullscreen',
    exitFullscreenLabel: 'Exit Fullscreen',
    playbackSpeedLabel: 'Speed',
    captionsLabel: 'Captions'
}

export const UnsupportedModuleViewerMeta: UnsupportedModuleViewerMetaProps = {
    title: 'Module Type Not Supported',
    message: 'Viewing {type} modules is not currently supported.',
    supportedTypes: 'Currently supported: Document (PDF), Video (YouTube, Vimeo, etc.)'
}

export const TrainingModulePageMeta: TrainingModulePageMetaProps = {
    backButtonLabel: 'Back to Training Details',
    moduleLabel: 'Module {current} of {total}',
    previousModuleButton: 'Previous Module',
    nextModuleButton: 'Next Module',
    errorTitle: 'Error Loading Module',
    errorInvalidParameters: 'Invalid training or module parameters.',
    errorTrainingNotFound: 'Training not found.',
    errorModuleNotFound: 'Module not found in this training.',
    errorInvalidContent: 'Invalid training content format.',
    errorFileNotFound: 'Document file not found.',
    errorNoDocumentSource: 'No document URL or file specified for this module.',
    errorNoVideoSource: 'No video URL or file specified for this module.',
    errorGeneric: 'An error occurred while loading the module.',
    documentViewer: DocumentViewerMeta,
    videoViewer: VideoPlayerMeta,
    unsupportedViewer: UnsupportedModuleViewerMeta
}

export const TrainingModuleMeta: TrainingModuleMetaProps = {
    minutesSuffix: 'min'
}

export const VolunteerTrainingPageMeta: VolunteerTrainingPageMetaProps = {
    title: "Your Assigned Training",
    description: "Access and complete your assigned training modules",
    errorTitle: "Error",
    noTrainingMessage: "No training has been assigned to you yet.",
    viewButton: "View Training",
}

export const VolunteerPoliciesMeta: VolunteerPoliciesMetaProps = {
    title: "Policies",
    description: "Review and acknowledge required policies",
    errorTitle: "Error",
    noPoliciesMessage: "No policies have been assigned to you yet.",
    outstandingTitle: "Outstanding Policies",
    acknowledgedTitle: "Acknowledged Policies",
    viewButton: "View Policy",
}

export const VolunteerTrainingPageDetailsMeta: VolunteerTrainingPageDetailsMetaProps = {
    backToTrainingsButton: 'Back to Trainings',
    loadingText: 'Loading Training',
    errorTitle: 'Error while loading training details.',
    modulesLabel: 'Modules',
    totalDurationLabel: 'Total Duration',
    minutesSuffix: 'min',
    mandatoryBadge: 'Mandatory',
    completedBadge: 'Completed',
    inProgressBadge: 'In Progress',
    moduleNumberPrefix: 'Module',
    completeTrainingButton: 'Mark as Complete',
    trainingCompletedMessage: 'This training has been successfully completed.',
}

export const ModuleCompletionModalMeta: CompletionQuestionsModalMetaProps = {
    title: "Module Questions",
    submitButton: "Submit Answers",
    submittingButton: "Completing Module",
    cancelButton: "Cancel"
}

export const ProfileMeta: VolunteerProfileMetaProps = {
    loadingText: 'Loading...',
    errorTitle: 'Error',
    backToVolunteersButton: 'Back to Volunteers',
    editProfileButton: 'Edit Profile',
    completeProfileButton: 'Complete Profile',
    noAreasMessage: '',
    csid: 'Volunteer ID',
    first_name: 'First Name',
    last_name: 'Last Name',
    second_last_name: 'Second Last Name',
    gender: 'Gender',
    dob: 'Date of Birth',
    age: 'Age',
    email: 'Email',
    phone: 'Phone',
    country_code: 'Country Code',
    country: 'Country',
    country_of_birth: 'Country of Birth',
    jamat_khana: 'Jamatkhana',
    service_location: 'Service Location',
    service_record: 'IV Position',
    family_origin: 'Family Origin',
    languages: 'Languages',
    support_needs: 'Special Support Needs',
    multi_faith_family: 'Inter-Faith Family',
    ismaili: 'Ismaili',
    registered_volunteer_label: 'Registered Volunteer',
    eligible_for_duty_label: 'Eligible for Duty',
    yes: 'Yes',
    no: 'No',
    personalInfoSection: 'Personal Information',
    locationSection: 'Location Information',
    additionalInfoSection: 'Volunteer Information',
    preferencesSection: 'Preferences',
    flagsSection: 'Additional Information',
    trainingsSection: 'Assigned Trainings',
    deleteTrainingMessage: 'Are you sure? This training will be unassigned from the volunteer and they will lose all associated progress.',
    deleteTrainingTitle: 'Unassign Training',
    languageSection: 'Languages',
    volunteer_for_visit_label: 'Would like to volunteer for Didar?',
    availability_label: 'Availability',
    uploadedDocumentsLabel: "Uploaded Documents",
    allocatedShiftsLabel: "Allocations",
    eventLeadLabel: "Event Lead",
    areaLeadLabel: "Area Lead",
    shiftLeadLabel: "Shift Lead",
    otherAllocationLabel: "Others",
    negativeListLabel: "Cannot perform duties"
}

export const VolunteerTableMeta = {
    columns: [
        { key: "csid", header: "VID" },
        { key: "first_name", header: "First Name" },
        { key: "last_name", header: "Last Name" },
        { key: "email", header: "Email" },
        { key: "phone", header: "Phone Number" },
        { key: "gender", header: "Gender" },
        //{ key: "dob", header: "DOB" },
        { key: "age", header: "Age" },
        { key: "country_of_birth", header: "Country of Birth" },
        { key: "family_origin", header: "Family Origin" },
        { key: "jamat_khana", header: "Jamatkhana" },
        { key: "service_record", header: "IV Position" },
        { key: "ismaili", header: "Ismaili" },
        { key: "multi_faith_family", header: "Inter-Faith Family" },
        { key: "eligible_for_duty", header: "Eligible for Duty" },
        { key: "languages", header: "Languages" },
        { key: "preferences", header: "Preferences" },
        { key: "flags", header: "Additional Skills" },
        //{ key: "support_needs", header: "Special Support" },
    ],
};


export const VolunteerTrainingTableMeta = {
    columns: [
        { key: "csid", header: "VID" },
        { key: "first_name", header: "First Name" },
        { key: "last_name", header: "Last Name" },
        { key: "gender", header: "Gender" },
        //{ key: "dob", header: "DOB" },
        // { key: "age", header: "Age" },
        { key: "service_record", header: "IV Position" },
        { key: "preferences", header: "Preferences" },
        { key: "flags", header: "Additional Skills" },
    ],
};

export const VolunteerAllocationTableMeta = {
    columns: [
        { key: "first_name", header: "First Name" },
        { key: "last_name", header: "Last Name" },
        // { key: "gender", header: "Gender" },
        { key: "jamat_khana", header: "Jamatkhana" },
        { key: "family_origin", header: "Family Origin" },
        { key: "service_record", header: "IV Position" },
        { key: "flags", header: "Additional Skills" },
    ],
};

export const ConflictInformationTableMeta = {
    columns: [
        { key: "event_name", header: "Event" },
        { key: "area_name", header: "Area" },
        { key: "shift_title", header: "Shift" },
        { key: "shift_duty_name", header: "Duty" },
        { key: "start_time", header: "Shift Start" },
        { key: "end_time", header: "Shift End" },
        { key: "type", header: "Reason" },
        { key: "action", header: "Actions" },
    ],
};

export const VolunteerAllocationViewTableMeta = {
    columns: [
        { key: "first_name", header: "First Name" },
        { key: "last_name", header: "Last Name" },
        { key: "phone", header: "Phone Number" },
        { key: "age_band", header: "Age Band" },
        { key: "jamat_khana", header: "Jamatkhana" },
        { key: "family_origin", header: "Family Origin" },
        { key: "service_record", header: "IV Position" },
        { key: "flags", header: "Additional Skills" },
        { key: "support_needs", header: "Support Needs" },
        { key: "action", header: "Actions" },
    ],
};

export const VolunteerEventShiftViewTableMeta = {
    columns: [
        { key: "event_name", header: "Event" },
        { key: "area_name", header: "Area" },
        { key: "shift_duty_name", header: "Shift" },
        { key: "start_time", header: "Shift Start" },
        { key: "end_time", header: "Shift End" },
        { key: "status", header: "Status" },
        { key: "action", header: "Action" }
    ],
};

export const VolunteerAreaShiftViewTableMeta = {
    columns: [
        { key: "shift_duty_name", header: "Shift" },
        { key: "start_time", header: "Shift Start" },
        { key: "end_time", header: "Shift End" },
        { key: "status", header: "Status" },
        { key: "action", header: "Action" }
    ],
};


export const LeadAssginmentViewTableMeta = {
    columns: [
        { key: "first_name", header: "First Name" },
        { key: "last_name", header: "Last Name" },
        { key: "email", header: "Email" },
        { key: "phone", header: "Phone Number" },
        { key: "flags", header: "Additional Skills" },
    ],
};

export const MIVolunteerViewMeta = {
    columns: [
        { key: "first_name", header: "First Name" },
        { key: "last_name", header: "Last Name" },
        { key: "email", header: "Email" },
        { key: "phone", header: "Phone Number" },
        { key: "jamat_khana", header: "Jamatkhana" },
        { key: "family_origin", header: "Family Origin" },
        { key: "service_record", header: "IV Position" },
        { key: 'country', header: "Country" },
        { key: "uk_didar_registration_ack", header: "Didar Acknowledgement" }

    ],
};



export const AssignTrainingFormModalMeta: AssignTrainingFormModalMetaProps = {
    title: "Assign Trainings to Volunteer",
    submitButton: "Assign",
    submittingButton: "Assigning",
    cancelButton: "Cancel",
    trainingLabel: "Available Trainings",
    trainingPlaceHolder: "Select Training",
    addTrainingButton: "Add Training",
    noTrainingMessage: 'No Trainings added yet. Click "Add Training" to add your first training.',
    noTrainingSelectedMessage: 'Add atleast one training to assign.'
}

export const AnnouncementMeta: AnnouncementMetaProps = {
    title: 'Announcements',
    description: 'Manage All your announcements made to the volunteers.',
    createButton: 'Post New',
    submitButton: 'Post',
    submittingButton: 'Posting...',
    errorTitle: 'Failed to Fetch Announcements',
    noAnnouncementsMessage: 'No Announcements have been posted yet.',
    announcementSearchPlaceHolder: 'Search Announcement By Title...',
    backButton: 'Back to Admin Hub',
    onDeleteTitle: 'Delete Announcement',
    onDeleteMessage: 'Deleting this announcement will permanently remove it for all users. This action cannot be undone.'
}

export const AnnouncementsFormModalMeta: AnnouncementFormModalMetaProps = {
    errorMessage: 'Error occured while posting form',
    createTitle: 'Post New Announcement',
    editTitle: 'Announcement Details',
    cancelButton: 'Cancel',
    submitButton: 'Post',
    submittingButton: 'Posting...',
    titleLabel: 'Title',
    titlePlaceHolder: 'Enter Announcement Title...',
    contentLabel: 'Content',
    contentPlaceHolder: 'Enter Announcement Content...',
    prioritiyMessage: 'Mark as Priority'
}

export const AnnouncementViewModalMeta: AnnouncementViewModalMetaProps = {
    viewTitle: 'Announcement',
    titleLabel: 'Title',
    contentLabel: 'Content',
    prioritiyMessage: 'This is a priority announcement.',
    cancelButton: 'Close'
}

export const BulkTrainingAssignmentFormMeta: BulkTrainingAssignmentFormMetaProps = {
    title: 'Assign ',
    cancelButton: 'Cancel',
    submitButton: 'Assign Training',
    submittingButton: 'Assigning...',
    previewButton: 'Preview',
    previewingButton: 'Loading...',
    // Assignment mode selection
    assignmentModeLabel: 'Assignment Method',
    modeAllVolunteers: 'All Registered Volunteers',
    modeAllVolunteersDescription: 'Assign to all approved volunteers in the system',
    modeByEvent: 'By Event',
    modeByEventDescription: 'Assign to volunteers allocated to specific events',
    modeByArea: 'By Area',
    modeByAreaDescription: 'Assign to volunteers allocated to specific areas',
    modeByShift: 'By Shift',
    modeByShiftDescription: 'Assign to volunteers allocated to specific shifts',
    modeByDuty: 'By Duty Type',
    modeByDutyDescription: 'Assign to volunteers allocated to shifts with specific duty types',
    modeManual: 'Manual Selection',
    modeManualDescription: 'Manually filter and select individual volunteers',
    // Selection labels
    selectEventsLabel: 'Select Events',
    selectAreasLabel: 'Select Areas',
    selectShiftsLabel: 'Select Shifts',
    selectDutiesLabel: 'Select Duty Types',
    // Lead inclusion options
    includeLeadsLabel: 'Include Leads',
    includeEventLeadsLabel: 'Include Event Leads',
    includeAreaLeadsLabel: 'Include Area Leads',
    includeShiftLeadsLabel: 'Include Shift Leads',
    // Preview results
    previewResultsTitle: 'Preview',
    totalVolunteersLabel: 'Total volunteers matching criteria',
    alreadyAssignedLabel: 'Already have this training',
    willBeAssignedLabel: 'Will be assigned',
    // Messages
    noSelectionMessage: 'Please select at least one item',
    selectEventFirst: 'Select an event first to see areas',
    selectAreaFirst: 'Select an area first to see shifts'
}

export const ShiftAssignmentFormMeta: ShiftAssignmentFormMetaProps = {
    title: 'Allocate Volunteers',
    cancelButton: 'Cancel',
    submitAllocateButton: 'Allocate',
    submittingAllocateButton: 'Allocating...',
    submitRemoveButton: 'Remove',
    submittingRemoveButton: 'Removing...',
    conflictTitle: 'Conflicting Shfits',
    conflictMessage: 'The following shifts are conflicting with this alloaction.',
    futureConflictMessage: 'The following shifts will conflict with this alloaction.',
    duplicationsModalTitle: (firstName: string, lastName: string) => `Duplications for ${firstName} ${lastName}`,
    shiftAllocationsTitle: (count: number) => `Shift Allocations (${count})`,
    excludedAllocationsTitle: (count: number) => `Excluded from Duplicate Count (${count})`,
    excludedAllocationsDescription: 'These allocations are from events not included in duplicate checks.',
    coreTeamAssignmentsTitle: (count: number) => `Core Team Assignments (${count})`,
    leadPositionsTitle: (count: number) => `Lead/Deputy Lead Positions (${count})`,
    excludedLeadPositionsTitle: (count: number) => `Excluded Lead Positions (${count})`,
    excludedLeadPositionsDescription: 'These lead positions are from events not included in duplicate checks.',
    positionTypeColumn: 'Type',
    statusColumn: 'Status',
    eventColumn: 'Event',
    areaColumn: 'Area',
    shiftColumn: 'Shift',
    actionsColumn: 'Actions',
    dateTimeColumn: 'Date/Time',
    noDuplicationsMessage: 'No other allocations or core team assignments found.',
    closeModalButton: 'Close',
    submittedStatus: 'Submitted',
    approvedStatus: 'Approved',
    pendingStatus: 'Pending',
    acceptedStatus: 'Accepted',
    declinedStatus: 'Declined',
    roleColumn: 'Role',
    streamsColumn: 'Streams',
    publishShiftTitle: 'Submit Shift for Approval?',
    publishShiftMessage: 'Once this shift is submitted, no further allocations can be made or removed.',
    publishButton: 'Submit for Approval',
    lockButton: 'Lock',
    unlockButton: 'Unlock'
}

export const AllLanguages = [
    "Arabic",
    "Persian / Farsi",
    "Bengali",
    "English",
    "Gujarati / Kutchi",
    "Urdu / Hindi",
    "Punjabi / Sindhi",
    "French",
    "German",
    "Mandarin Chinese / Japanese",
    "Portuguese",
    "Russian",
    "Spanish",
    "Swahili",
    "Turkish",
    "Tajik",

    "Danish",
    "Swedish",
    "Norwegian",
    "Finish",
    "Dutch",
    "Polish",
    "Italian",
]

export const IVPositions = [
    "Non-Uniformed Volunteer",
    "Uniformed Volunteer"
]

export const IVPositionFilterOptions = [
    "Non-Uniformed Volunteer",
    "Uniformed Volunteer",
    "Volunteer",
    "Junior Volunteer",
    "Team Leader",
    "JV Team Leader",
    "Deputy JV Team Leader",
    "Director",
    "Deputy Director",
    "IV Executive",
    "IV Events",
    "Other"
]

export const GenderOptions = [
    "Male",
    "Female",
    "Prefer Not to Say"
]

export const UserMetaProps = {
    title: 'User Management',
    description: 'Manage users and roles with access control',
    errorTitle: 'Error Loading Users',
}
export const UserFormModalMeta: UserFormModalMetaProps = {
    title: 'Create New User',
    nameLabel: 'Full Name',
    namePlaceholder: 'Enter full name',
    emailLabel: 'Email',
    emailPlaceholder: 'Enter email address',
    roleLabel: 'Role',
    rolePlaceholder: 'Select role',
    submitButton: 'Create User',
    submittingButton: 'Creating...',
    cancelButton: 'Cancel',
    closeButton: 'Close',
    errorMessage: 'Failed to create user. Please try again.',
    usernameLabel: 'Username',
    usernamePlaceholder: 'Username',
}

export const UpdateUserFormMeta: UpdateUserFormMetaProps = {
    title: 'Edit User',
    submitButton: 'Update User',
    submittingButton: 'Updating...'
}
export const DeleteUserMeta: DeleteUserMetaProps = {
    deleteButtonText: 'Delete User',
    confirmTitle: 'Delete User',
    confirmMessage: 'Are you sure you want to delete this user? This action cannot be undone and will remove the selected user.'
}
export const DEFAULT_FILTERS: VolunteerFiltersWithConflictProps = {
    name: "",
    email: "",
    phone_number: "",
    id: "",
    country: "eu",
    age: null,
    country_of_birth: "",
    family_origin: "",
    jamat_khana: "",
    iv_position: "",
    ismaili: null,
    registered_volunteer: null,
    profile_submitted: true,
    approved_volunteer: null,
    eligible_for_duty: true,
    multi_faith_family: null,
    has_support_needs: null,
    tags: [],
    preferences: [],
    languages: [],
    service_record: [],
    genders: [],
    trainings: [],
    training_filter_type: 'at_least_one',
    age_start: 18,
    age_end: null,
    conflict: null,
    status: null,
    volunteer_for_visit: 1,
    iiuk_registeration: "any", // "iiuk"
    availability: [],
    availability_filter_type: 'at_least_one',
    event_assignment_type: null,
    event_assignment_events: [],
    documents: [],
    allocation_status: [],
    core_team_assignment_type: null,
    clusters: []
};

export const LeadAssignModalMeta: LeadAssignModalPropsMeta = {
    cancelButton: "Cancel",
    selectButton: "Select",
    nameSearchPlaceholder: 'Search by name...',
    emailSearchPlaceholder: 'Search by email...',
    phoneSearchPlaceholder: 'Search by phone...',
    idSearchPlaceholder: 'Search by ID...',
    searchButton: 'Search',
    clearButton: 'Clear',
    showingLabel: 'Showing',
    volunteersLabel: 'volunteers',
    noResultsMessage: 'No volunteers found matching your search',
    noVolunteersMessage: 'No volunteers available',
    idColumn: 'ID',
    nameColumn: 'Name',
    phoneColumn: 'Phone',
    emailColumn: 'Email',
    jamatKhanaColumn: 'Jamatkhana',
    duplicationsColumn: 'Duplications',
    viewDuplicationsButton: (count: number) => `View (${count})`,
    actionColumn: 'Action',
    duplicationsModalTitle: (firstName: string, lastName: string) => `Duplications for ${firstName} ${lastName}`,
    shiftAllocationsTitle: (count: number) => `Shift Allocations (${count})`,
    excludedAllocationsTitle: (count: number) => `Excluded from Duplicate Count (${count})`,
    excludedAllocationsDescription: 'These allocations are from events not included in duplicate checks.',
    coreTeamAssignmentsTitle: (count: number) => `Core Team Assignments (${count})`,
    leadPositionsTitle: (count: number) => `Lead/Deputy Lead Positions (${count})`,
    excludedLeadPositionsTitle: (count: number) => `Excluded Lead Positions (${count})`,
    excludedLeadPositionsDescription: 'These lead positions are from events not included in duplicate checks.',
    positionTypeColumn: 'Type',
    statusColumn: 'Status',
    eventColumn: 'Event',
    areaColumn: 'Area',
    shiftColumn: 'Shift',
    dateTimeColumn: 'Date/Time',
    noDuplicationsMessage: 'No other allocations or core team assignments found.',
    closeModalButton: 'Close',
    submittedStatus: 'Submitted',
    approvedStatus: 'Approved',
    pendingStatus: 'Pending',
    acceptedStatus: 'Accepted',
    declinedStatus: 'Declined',
    roleColumn: 'Role',
    streamsColumn: 'Streams'
}

export const AccessColorMeta: AccessColorMetaProps = {
    title: 'Access Colors',
    description: 'Manage all access colors..',
    createButton: 'Create New',
    submitButton: 'Create',
    submittingButton: 'Creating...',
    errorTitle: 'Failed to fetch access colors',
    noAnnouncementsMessage: 'No access colors have been created yet.',
    backButton: 'Back to Admin Hub',
    onDeleteTitle: 'Delete Access Color',
    onDeleteMessage: 'Deleting this access will permanently remove it for all users. This action cannot be undone.'
}

export const AccessColorFormModalMeta: AccessColorFormModalMetaProps = {
    title: 'Create New Access Color',
    submitButton: 'Create Color',
    submittingButton: 'Creating...',
    cancelButton: 'Cancel',
    closeButton: 'Close',
    errorMessage: 'Failed to create access color. Please try again.',
    colorLabel: 'Selected Color',
    presetColorLabel: "Preset Colors",
    updateButton: 'Update Color',
    updatingButton: 'Updating Button'

}

export const COLOR_PRESETS = [
    '#EF4444', // red
    '#F97316', // orange
    '#FACC15', // yellow
    '#22C55E', // green
    '#3B82F6', // blue
    '#6366F1', // indigo
    '#8B5CF6', // purple
    '#EC4899', // pink
    '#6B7280', // gray
];

export const AVAILABILITY_OPTIONS = [
    "Setup Support (3rd July)",
    "Pre Didar (4th July)",
    "Didar Day (5th July)",
    "Post Didar (6th July)"
] as const


export const VOLUNTEER_FOR_VISIT_MAP = {
    1: "Yes, I would like to volunteer",
    0: "No, not available at this time",
    null: "No Selection" // default case
} as const

export const VOLUNTEER_FOR_VISIT_MAP_INVERSE = {
    "Yes, I would like to volunteer": 1,
    "No, not available at this time": 0,
    "Unspecified": "null",
} as const

export const TrainingSequenceEditMeta: TrainingSequenceEditMetaProps = {
    title: 'Edit Training Sequence',
    message: 'Drag trainings to change their sequence.',
    cancelButton: 'Cancel',
    submitButton: 'Update',
    submittingButton: 'Updating...'
}

export const VolunteerOverviewMeta: VolunteerOverviewMetaProps = {
    title: 'Volunteer Summary',
    description: 'Overview of volunteers demographics',
    errorTitle: 'Error while fetching volunteer information',
    loadingText: 'Loading'
}

export const TrainingsOverviewMeta: TrainingsOverviewMetaProps = {
    title: 'Trainings Overview',
    description: 'Overview of training assignments',
    loadingText: 'Loading...',
    errorTitle: 'Error Loading Training Data'
}

export const AllocationsOverviewMeta: AllocationsOverviewMetaProps = {
    title: 'Allocations Summary',
    description: 'Overview of allocations demographics',
    eventsCardTitle: 'Total Events',
    areaCardTitle: 'Total Areas',
    shiftCardTitle: 'Total Shifts',
    volunteersCardTitle: 'Total Volunteers',
    allocationsCardTitle: 'Total Allocations',
    allocationStatusTitle: 'Allocation Status',
    pendingLabel: 'Pending',
    acceptedLabel: 'Accepted',
    declinedLabel: 'Declined',
    loadingText: 'Loading dashboard...',
    errorTitle: 'Error Loading Dashboard'
}

export const CoreStreamOverviewMeta: CoreStreamOverviewMetaProps = {
    title: 'Core Tream Streams Overview',
    description: 'Overview of core team streams assignments',
    loadingText: 'Loading...',
    errorTitle: 'Error Loading Core Tream Data',
    noDataMessage: 'No core stream data avaialble.'
}

export const VolunteerStatsTableOverviewMeta: VolunteerStatsTableOverviewMetaProps = {
    title: 'Volunteer Statistics',
    description: 'Overview of volunteer demographic statistics',
    loadingText: 'Loading...',
    errorTitle: 'Error Loading Statistics Data.',
    noDataMessage: 'No statistics data avaialble.'
}

export const DidarAcknowledgementOverviewMeta: DidarAcknowledgementOverviewMetaProps = {
    title: 'Didar Acknowledgement Overview',
    description: 'Overview of didar acknowledgements',
    loadingText: 'Loading...',
    errorTitle: 'Error Loading Acknowledgement Data.',
    noDataMessage: 'No acknowledgement data avaialble.'
}


export const DashboardMeta: DashboardMetaProps = {
    title: 'Dashboard',
    description: 'Overview of users, volunteers and allocations',
    eventsCardTitle: 'Total Events',
    areaCardTitle: 'Total Areas',
    shiftCardTitle: 'Total Shifts',
    volunteersCardTitle: 'Total Volunteers',
    allocationsCardTitle: 'Total Allocations',
    allocationStatusTitle: 'Allocation Status',
    pendingLabel: 'Pending',
    acceptedLabel: 'Accepted',
    declinedLabel: 'Declined',
    loadingText: 'Loading dashboard...',
    errorTitle: 'Error Loading Dashboard'
}


export const MangementAnalyticsMeta: ManagementAnalyticsMetaProps = {
    title: 'Statistics',
    description: 'Views & Filters',
    errorTitle: 'Error while fetching data information',
    loadingText: 'Loading...'
}

export const CHART_COLORS = [
    "#2563eb", // blue
    "#16a34a", // green
    "#f59e0b", // amber
    "#dc2626", // red
    "#7c3aed", // violet
    "#0891b2", // cyan
    "#9333ea", // purple
    "#65a30d", // lime
    "#0f766e", // teal
    "#be123c", // rose
    "#ea580c", // orange
    "#1d4ed8", // indigo
    "#15803d", // dark green
    "#854d0e", // brown/gold
    "#9f1239", // dark rose
    "#0369a1", // sky blue
    "#4d7c0f", // olive
    "#6b21a8", // deep purple
    "#b91c1c", // dark red
    "#0f172a", // slate (near-black)
];




export const CHART_HEIGHT_MAP: Record<MaxChartSize, number> = {
    sm: 220,
    md: 260,
    lg: 300,
    xl: 340,
    '2xl': 380,
    '3xl': 420,
    '4xl': 460,
    '5xl': 520,
    '6xl': 580,
    '7xl': 640,
    '8xl': 720,
    '9xl': 800,
    '10xl': 880,
};

export const CHART_WIDTH_CLASSES: Record<MaxChartSize, string> = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '4xl': 'max-w-4xl',
    '5xl': 'max-w-5xl',
    '6xl': 'max-w-6xl',
    '7xl': 'max-w-7xl',
    '8xl': 'max-w-8xl',
    '9xl': 'max-w-9xl',
    '10xl': 'max-w-10xl',
};

export const ANALYTICS_TABS: { key: AnalyticsTab; label: string }[] = [
    { key: "dashboard", label: "Dashboard" },
    { key: "trainings", label: "Trainings Overview" },
    { key: "volunteers", label: "Volunteers Demographics" },
    { key: "volunteertable", label: "Volunteers Statistics" },
    { key: "didar", label: "Didar Acknowledgements" },
    { key: "iff", label: "Inter-Faith-Family Demographics" },
    { key: "non-iiuk", label: "Non-IIUK Volunteer Demographics" },
    { key: 'duty_acceptance', label: "Duty Acceptance Statistics" },
    { key: 'check-in', label: 'Check-In Demographics' },
];

export const InternationalRegisterationsMeta: InternationalRegisterationsMetaProps = {
    title: "International Registrations",
    description: "Following international registrations have been received.",
    errorTitle: "Error occur while fetching international registrations.",
    noDataMessage: "No registrations available.",
    loadingText: "Loading registration request",
    exportButton: "Export to CSV",
    lastSignInColumn: "Last Sign In",
    neverSignedInText: "Never signed in",
}

export const ShiftStatusMap = {
    0: 'Open',
    1: 'In Review',
    2: 'Approved',
    3: 'Rejected'
}

export const EmailCampaignsMeta: EmailCampaignsMetaProps = {
    title: 'Email Campaigns',
    description: 'Create and manage email blasts to volunteers',
    createButton: 'Create Campaign',
    subjectLabel: 'Subject',
    statusLabel: 'Status',
    recipientsLabel: 'Recipients',
    progressLabel: 'Progress',
    createdLabel: 'Created',
    actionsLabel: 'Actions',
    editButton: 'Edit',
    deleteButton: 'Delete',
    viewButton: 'View',
    statusDraft: 'Draft',
    statusTestSent: 'Test Sent',
    statusPendingApproval: 'Pending Approval',
    statusSending: 'Sending',
    statusCompleted: 'Completed',
    statusFailed: 'Failed',
    pendingApprovalCountLabel: (count) => `${count} pending approval`,
    showPendingApprovalOnlyLabel: 'Show pending approval only',
    showAllCampaignsLabel: 'Show all campaigns',
    noPendingApprovalCampaignsMessage: 'No campaigns are currently waiting for approval.',
    noCampaignsMessage: 'No email campaigns found. Create your first campaign to get started.',
    loadingText: 'Loading campaigns...',
    errorTitle: 'Error loading campaigns',
    deleteConfirmTitle: 'Delete Campaign',
    deleteConfirmMessage: 'Are you sure you want to delete this campaign? This action cannot be undone.',
    cancelButton: 'Cancel',
    confirmDeleteButton: 'Delete Campaign',
    exportRecipientsButton: 'Export Recipients'
}

export const EmailCampaignFormMeta: EmailCampaignFormMetaProps = {
    createTitle: 'Create Email Campaign',
    editTitle: 'Edit Email Campaign',
    subjectLabel: 'Email Subject',
    subjectPlaceholder: 'Enter email subject...',
    bodyLabel: 'Email Body',
    bodyPlaceholder: 'Compose your email message...',
    saveDraftButton: 'Save Draft',
    cancelButton: 'Cancel',
    previewButton: 'Preview',
    sendTestButton: 'Send Test',
    sendCampaignButton: 'Send Campaign',
    submitForApprovalButton: 'Submit for Approval',
    approveCampaignButton: 'Approve and Send',
    denyCampaignButton: 'Deny and Reopen',
    testEmailsLabel: 'Test Email Addresses',
    testEmailsPlaceholder: 'email@example.com',
    testEmailsHint: 'Enter up to 10 email addresses to send test emails',
    addEmailButton: 'Add Email',
    removeEmailButton: 'Remove',
    confirmSendTitle: 'Send Email Campaign',
    confirmSendMessage: (count) => `You are about to send this email to ${count} recipients. This action cannot be undone. Are you sure?`,
    confirmSubmitTitle: 'Submit Campaign for Approval',
    confirmSubmitMessage: (count) => `Submit this campaign for approval with ${count} sendable recipient${count !== 1 ? 's' : ''}? The content and recipients will be locked.`,
    confirmApproveTitle: 'Approve and Send Campaign',
    confirmApproveMessage: (count) => `Approve this campaign and start sending it to ${count} recipient${count !== 1 ? 's' : ''}? This action cannot be undone.`,
    confirmDenyTitle: 'Deny Campaign',
    confirmDenyMessage: 'Deny this campaign and reopen it for editing? The creator will be able to update the content and recipients before submitting it again.',
    confirmDenyButton: 'Deny Campaign',
    noTestSentWarning: '⚠️ Warning: You have not sent any test emails yet. It is recommended to send test emails before sending to all volunteers.',
    confirmButton: 'Confirm Send',
    errorSaving: 'Failed to save campaign',
    errorLoading: 'Failed to load campaign',
    successSaved: 'Campaign saved successfully',
    successTestSent: 'Test email(s) sent successfully',
    successSent: 'Campaign is being sent',
    successSubmitted: 'Campaign submitted for approval',
    successDenied: 'Campaign denied and reopened for editing',
    contentLockedPendingApproval: 'This campaign has been submitted for approval. The content and recipients are locked until an approver starts sending it.',
    // Targeting criteria
    targetingTitle: 'Add Recipients by Group',
    targetingDescription: 'Select a targeting method to add a group of recipients',
    allVolunteersLabel: 'All volunteers with submitted profiles',
    targetEventLabel: 'Filter by event (optional)',
    targetAreaLabel: 'Filter by area (optional)',
    targetShiftLabel: 'Filter by shift (optional)',
    targetDutyLabel: 'Filter by duty type (optional)',
    selectEventPlaceholder: 'All events (all volunteers)',
    selectAreaPlaceholder: 'All areas in this event',
    selectShiftPlaceholder: 'All shifts in this area',
    selectDutyPlaceholder: 'All duty types',
    loadingEvents: 'Loading events...',
    loadingAreas: 'Loading areas...',
    loadingShifts: 'Loading shifts...',
    loadingDuties: 'Loading duties...',
    includeLeadsLabel: 'Also include leads:',
    includeEventLeadsLabel: 'Event leads',
    includeAreaLeadsLabel: 'Area leads/deputies',
    includeShiftLeadsLabel: 'Shift leads/deputies',
    // Volunteer types and volunteer filters for "all volunteers" option
    volunteerTypesLabel: 'Volunteer Types',
    volunteerTypeIiukUkIreland: 'IIUK registered (Local - Europe)',
    volunteerTypeIiukEurope: 'IIUK registered (International)',
    volunteerTypeNonIiuk: 'Volunteer Community (non-IIUK)',
    volunteerForVisitLabel: 'Volunteering During Didar',
    volunteerForVisitYes: 'Volunteering during Didar (have provided availability)',
    volunteerForVisitNo: 'No - not available to volunteer',
    volunteerForVisitBoth: 'Both (all responses)',
    // Recipient management
    recipientManagementTitle: 'Manage Recipients',
    recipientManagementDescription: 'Add recipients individually or by group. Duplicates are automatically removed.',
    recipientSourceHistoryTitle: 'Recipient Source History',
    recipientSourceHistoryDescription: 'Review how recipients were added before approving this campaign.',
    recipientSourceNoHistory: 'No source history has been recorded for this campaign. It may have been created before tracking was added.',
    recipientSourceAddedLabel: 'Added',
    recipientSourceSelectedLabel: 'Selected',
    recipientSourceDuplicatesLabel: 'Duplicates skipped',
    recipientSourceWithoutEmailLabel: 'Missing email',
    recipientSourceTotalAfterLabel: 'Total after change',
    recipientSourceAddedByLabel: 'By',
    recipientSourceShowButton: 'Show History',
    recipientSourceHideButton: 'Hide History',
    recipientListTitle: 'Recipient List',
    noRecipientsMessage: 'No recipients added yet. Use the buttons above to add recipients.',
    addGroupButton: 'Add Group',
    addIndividualButton: 'Add Individual',
    clearAllButton: 'Clear All',
    recipientCountLabel: (count) => `${count} recipient${count !== 1 ? 's' : ''}`,
    removeRecipientButton: 'Remove',
    searchVolunteersPlaceholder: 'Search volunteers by name...',
    addSelectedButton: 'Add Selected',
    groupAddedMessage: (added, total) => `Added ${added} new recipient${added !== 1 ? 's' : ''}. Total: ${total}`,
    individualAddedMessage: (added, total) => `Added ${added} recipient${added !== 1 ? 's' : ''}. Total: ${total}`,
    clearConfirmTitle: 'Clear All Recipients',
    clearConfirmMessage: 'Are you sure you want to remove all recipients from this campaign?',
    confirmClearButton: 'Clear All',
    // Email suggestions
    emailSuggestionsTitle: 'Set Email Address',
    emailSuggestionsDescription: 'Select an email address for',
    customEmailLabel: 'Enter Custom Email',
    saveButton: 'Save',
    noEmailSuggestions: 'No suggestions available. Please enter an email manually.',
    // Retry failed
    retryFailedButton: 'Retry Failed',
    retryFailedConfirmTitle: 'Retry Failed Emails',
    retryFailedConfirmMessage: (count: number) => `You are about to retry sending to ${count} failed recipient${count !== 1 ? 's' : ''}. Continue?`,
    confirmRetryButton: 'Retry',
    successRetry: (count: number) => `Retrying ${count} failed email${count !== 1 ? 's' : ''}...`
}

export const EmailCampaignPreviewMeta: EmailCampaignPreviewMetaProps = {
    title: 'Email Preview',
    closeButton: 'Close',
    backButton: 'Back to Edit',
    testWarningTitle: 'Test Email Notice',
    testWarningMessage: 'This banner will appear in test emails only. It will not be included in the actual campaign.'
}

export const ShiftMoveModalMeta: ShiftMoveModalMetaProps = {
    title: "Move Volunteer",
    submitButton: "Move",
    submittingButton: "Moving...",
    closeButton: "Cancel",
    eventLabel: "Event",
    areaLabel: "Area",
    shiftLabel: "Shift",
    eventPlaceHolder: "Select Event",
    areaPlaceHolder: "Select Area",
    shiftPlaceHolder: "Select Shift"
}


export const VolunteerUploadDocumentFormMeta: VolunteerUploadDocumentFormMetaProps = {
    title: "Upload Document",
    cancelButton: "Cancel",
    submitButton: "Upload",
    submittingButton: "Uploading...",
    documentTypeLabel: "Document Type"
}

export const UPLOAD_DOCUMENT_TYPES = ["DBS (Standard)", "DBS (Enhanced)", "First Aid", "Medical Certificate"]

export const AllocationStatusPageMeta: AllocationStatusPageMetaProps = {
    title: 'Duty Acceptance Management',
    description: 'View and manage volunteer duty acceptance statuses, filter by various criteria, and re-allocate volunteers as needed.',
    backLink: '← Back to Admin Hub',
    // Status badges
    pendingLabel: 'Pending',
    acceptedLabel: 'Accepted',
    declinedLabel: 'Declined',
    allLabel: 'All',
    // Filter labels
    filtersTitle: 'Filters',
    statusFilterLabel: 'Status',
    eventFilterLabel: 'Event',
    areaFilterLabel: 'Area',
    shiftFilterLabel: 'Shift',
    volunteerSearchLabel: 'Search Volunteer',
    volunteerSearchPlaceholder: 'Search by name, email, or ID...',
    declineReasonFilterLabel: 'Decline Reason',
    dateRangeLabel: 'Response Date Range',
    dateFromLabel: 'From',
    dateToLabel: 'To',
    offeredAsTknLabel: 'Offered as TKN',
    // Volunteer count filters
    volunteerCountsTitle: 'Filter by Volunteer Response Counts',
    volunteerCountsEventsLabel: 'Count responses in events:',
    volunteerCountsEventsAllLabel: 'All Events',
    minPendingCountLabel: 'Min Pending',
    maxPendingCountLabel: 'Max Pending',
    minAcceptedCountLabel: 'Min Accepted',
    maxAcceptedCountLabel: 'Max Accepted',
    minDeclinedCountLabel: 'Min Declined',
    maxDeclinedCountLabel: 'Max Declined',
    // Filter placeholders
    selectEventPlaceholder: 'All Events',
    selectAreaPlaceholder: 'All Areas',
    selectShiftPlaceholder: 'All Shifts',
    selectDeclineReasonPlaceholder: 'All Reasons',
    // Actions
    searchButton: 'Search',
    clearFiltersButton: 'Clear Filters',
    exportCsvButton: 'Export CSV',
    exportingButton: 'Exporting...',
    // Table
    tableVolunteerColumn: 'Volunteer',
    tableEventColumn: 'Event',
    tableAreaColumn: 'Area',
    tableShiftColumn: 'Shift',
    tableStatusColumn: 'Status',
    tableTknColumn: 'TKN',
    tableDeclineReasonColumn: 'Decline Reason',
    tableResponseDateColumn: 'Response Date',
    tableActionsColumn: 'Actions',
    // Bulk actions
    bulkActionsTitle: 'Bulk Actions',
    selectedCountLabel: (count) => `${count} selected`,
    changeStatusButton: 'Change Status',
    reAllocateButton: 'Re-allocate',
    setToPendingButton: 'Set to Pending',
    setToAcceptedButton: 'Set to Accepted',
    setToDeclinedButton: 'Set to Declined',
    // Messages
    noResultsMessage: 'No allocations found matching your criteria.',
    loadingMessage: 'Loading allocations...',
    errorMessage: 'An error occurred while loading allocations.',
    bulkUpdateSuccessMessage: (count) => `Successfully updated ${count} allocation${count !== 1 ? 's' : ''}.`,
    bulkUpdateErrorMessage: 'Failed to update allocations. Please try again.',
    // Re-allocate modal
    reAllocateTitle: 'Re-allocate Volunteer(s)',
    reAllocateDescription: 'Select a new shift to allocate the selected volunteer(s). This will create a new allocation without affecting the original one.',
    reAllocateEventLabel: 'Event',
    reAllocateAreaLabel: 'Area',
    reAllocateShiftLabel: 'Shift',
    reAllocateWarning: 'Note: The original allocation will remain unchanged. This creates a new allocation with pending status.',
    reAllocateDuplicateWarning: 'Warning: One or more volunteers already have an allocation for this shift.',
    reAllocateSubmitButton: 'Create New Allocation',
    reAllocatingButton: 'Creating...',
    reAllocateCancelButton: 'Cancel',
    reAllocateSuccessMessage: (count) => `Successfully created ${count} new allocation${count !== 1 ? 's' : ''}.`,
    reAllocateErrorMessage: 'Failed to create new allocations. Please try again.',
    // Pagination
    previousButton: 'Previous',
    nextButton: 'Next',
    pageLabel: 'Page',
    itemsPerPageLabel: 'Items per page',
    totalItemsLabel: (count) => `${count} total item${count !== 1 ? 's' : ''}`,
    // Decline reasons (copied from Home for consistency)
    declineReasons: [
        'Timing is not suitable (another shift may be offered, subject to availability)',
        'I do not wish to undertake this particular duty (another shift may be offered, subject to availability)',
        'Unable to commit at this time (I will visit the VRC on the day)',
        'I no longer wish to continue due to personal reasons'
    ],
    startTimeLabel: 'Start Time',
    endTimeLabel: 'End Time'
}

export const ALLOCATION_STATUS_OPTIONS = ["Accepted", "Declined", "Pending"]

export const CheckInPageMeta: CheckInPageMetaProps = {
    title: 'Volunteer Check-In',
    description: 'Scan volunteer badges or search by name to check them in for their assigned duties.',
    backToAdmin: 'Back to Admin',
    // Mode toggle
    scanModeLabel: 'Scan Badge',
    searchModeLabel: 'Search',
    // Scanner input
    scannerPlaceholder: 'Scan badge or enter barcode...',
    scannerLabel: 'Badge Scanner',
    scannerHint: 'Position the badge barcode in front of the scanner',
    // Search input
    searchPlaceholder: 'Search by name, email or ID...',
    searchLabel: 'Search Volunteer',
    searchHint: 'Enter at least 2 characters to search',
    searchButton: 'Search',
    searchingText: 'Searching...',
    searchResultsTitle: 'Search Results',
    noSearchResultsMessage: 'No volunteers found matching your search.',
    selectVolunteerButton: 'Select',
    // Event filter
    eventFilterLabel: 'Select Event',
    selectEventPrompt: 'Please select an event',
    // Volunteer display
    volunteerNotFoundMessage: 'Volunteer not found. Please try scanning again.',
    loadingMessage: 'Looking up volunteer...',
    errorMessage: 'An error occurred. Please try again.',
    scanToBeginMessage: 'Scan a volunteer badge to begin check-in',
    searchToBeginMessage: 'Search for a volunteer by name to begin check-in',
    // Volunteer card
    volunteerCardTitle: 'Volunteer Details',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    countryLabel: 'Country',
    jamatkhanaLabel: 'Jamatkhana',
    // Allocations
    allocationsTitle: 'Duty Allocations',
    noAllocationsMessage: 'No duty allocations found for this volunteer.',
    noAllocationsForEventMessage: 'No allocations for the selected event.',
    eventColumn: 'Event',
    areaColumn: 'Area',
    shiftColumn: 'Shift',
    timeColumn: 'Time',
    statusColumn: 'Acceptance',
    actionColumn: 'Check-In',
    // Check-in status
    checkedInLabel: 'Checked In',
    notCheckedInLabel: 'Not Checked In',
    checkedInAtLabel: (time) => `Checked in at ${time}`,
    checkedInByLabel: (name) => `by ${name}`,
    // Buttons
    checkInButton: 'Check In',
    undoCheckInButton: 'Undo',
    checkingInButton: 'Checking in...',
    deallocateDutyButton: 'Deallocate',
    deallocatingDutyButton: 'Removing...',
    scanAnotherButton: 'Scan Another',
    allocateDutyButton: 'Allocate Duty',
    // Messages
    checkInSuccessMessage: 'Check-in successful!',
    undoCheckInSuccessMessage: 'Check-in undone.',
    deallocateDutyConfirmMessage: (dutyName) => `Remove ${dutyName} from this volunteer? This cannot be undone.`,
    deallocateDutySuccessMessage: 'Duty deallocated successfully.',
    deallocateDutyErrorMessage: 'Failed to deallocate duty. Please try again.',
    checkInErrorMessage: 'Failed to check in. Please try again.',
    // Allocation status badges
    pendingStatusLabel: 'Pending',
    acceptedStatusLabel: 'Accepted',
    declinedStatusLabel: 'Declined',
    // Camera scanning
    cameraScanButton: 'Use Camera',
    cameraScannerTitle: 'Scan Badge with Camera',
    cameraScannerHint: 'Position the badge barcode in the camera view',
    cameraPermissionDenied: 'Camera access was denied. Please allow camera access to use this feature.',
    cameraNotSupported: 'Camera scanning is not supported on this device.',
    closeCameraButton: 'Close',
    // Shift View mode
    shiftViewModeLabel: 'Shift View',
    shiftViewAreaLabel: 'Area',
    shiftViewShiftLabel: 'Shift',
    shiftViewSelectAreaPrompt: 'Select an area',
    shiftViewSelectShiftPrompt: 'Select a shift',
    shiftViewNoAreasMessage: 'No areas found for the selected events.',
    shiftViewNoShiftsMessage: 'No shifts found for the selected area.',
    shiftViewLoadingVolunteers: 'Loading volunteers...',
    shiftViewNoVolunteersMessage: 'No volunteers allocated to this shift.',
    shiftViewVolunteerCount: (checked, total) => `${checked}/${total} Checked In`,
    shiftViewNameColumn: 'Name',
    shiftViewPhoneColumn: 'Phone',
    shiftViewTimeColumn: 'Time Slot',
    shiftViewStatusColumn: 'Status',
    shiftViewActionColumn: 'Action',
    // Create volunteer
    createVolunteerButton: "Can't find? Create here"
}

export const DutyStatusOverviewMeta: DutyStatusOverviewMetaProps = {
    title: "Duty Acceptance Statistics",
    description: "The following table is a breakdown of duty accpetance status for released shifts.",
    errorTitle: "Failed to fetch statistics.",
    loadingText: "Loading...",
    eventSelectionLabel: "Choose Events to Analyze"
}

export const QuickAllocateModalMeta: QuickAllocateModalMetaProps = {
    title: 'Quick Allocate Duty',
    subtitle: (volunteerName) => `Allocate a duty to ${volunteerName}`,
    // Search
    searchPlaceholder: 'Search shifts or areas...',
    // Sort options
    sortLabel: 'Sort by',
    sortByUrgency: 'Urgency',
    sortByStartTime: 'Start Time',
    sortByAlphabetical: 'Alphabetical',
    // Stats labels
    requiredLabel: 'Required',
    acceptedLabel: 'Accepted',
    checkedInLabel: 'Checked In',
    // Shift display
    noShiftsMessage: 'No available shifts found for this event.',
    loadingShiftsMessage: 'Loading shifts...',
    viewOtherShiftsButton: (count) => `View other shifts (${count})`,
    hideOtherShiftsButton: 'Hide other shifts',
    // Conflict labels
    alreadyAllocatedLabel: 'Already Allocated',
    timeConflictLabel: 'Time Conflict',
    // Buttons
    allocateButton: 'Allocate',
    allocatingButton: 'Allocating...',
    cancelButton: 'Cancel',
    closeButton: 'Close',
    // Messages
    allocationSuccessMessage: 'Duty allocated successfully!',
    allocationErrorMessage: 'Failed to allocate duty. Please try again.'
}

export const LiveOperationsMeta: LiveOperationsMetaProps = {
    title: "Live Event Operations",
    description: 'Monitor real-time volunteer attendance, shift coverage, and critical operational metrics.',
    errorTitle: 'Error',
    areaCheckBoxTitle: 'Select Areas',
    areaCheckBoxLabel: 'Select areas from shifts to be displayed',
    shiftsMeta: { title: 'Available Areas', description: 'The following areas requrie volunteer support' }
}

export const LIVE_OPERATIONS_TABS: { key: LiveStatusTab, header: string }[] = [
    { key: "checkin-stats", header: "Check-Ins" },
    { key: "shifts", header: "Urgent Shifts" },
]

export const LoginFormMeta: LoginFormMetaProps = {
    title: 'Non-IIUK Login',
    emailLabel: 'Email',
    emailPlaceholder: 'name@company.com',
    passwordLabel: 'Password',
    passwordPlaceholder: '••••••••',
    forgotPassword: 'Forgot your password?',
    loginButton: 'Login',
    createAccount: 'Create an Account',
    errorLabel: 'Error:',
    sending: 'Sending...',
    resendVerification: 'Resend Verification Email',
    travelInfo: 'If you are already planning to travel and would like to volunteer, please register your interest. Volunteering is based on personal arrangements, and all travel, accommodation, visa, and related requirements must be arranged independently.'
}

export const ForgetPasswordMeta: ForgetPasswordMetaProps = {
    back: 'Back',
    errorLabel: 'Error:',
    successLabel: 'Success!',
    successMessage: 'Please check your email inbox (and spam folder) for the password reset link.',
    title: 'Forgot Password',
    emailLabel: 'Email',
    emailPlaceholder: 'you@example.com',
    sendResetLink: 'Send Reset Link'
}

export const ResetPasswordMeta: ResetPasswordMetaProps = {
    errorLabel: 'Error:',
    successLabel: 'Success!',
    title: 'Reset Password',
    passwordLabel: 'Password',
    passwordPlaceholder: 'New password',
    confirmPasswordLabel: 'Confirm Password',
    confirmPasswordPlaceholder: 'Confirm New Password',
    resetting: 'Resetting...',
    resetButton: 'Reset Password',
    invalidLinkError: 'The password reset link is invalid or expired.',
    passwordsDoNotMatch: 'Passwords do not match.',
    missingTokenError: 'Missing token or email. Please use the link from your email.'
}

export const SignupMeta: SignupMetaProps = {
    checkEmailTitle: 'Check Your Email',
    checkEmailMessage: "We've sent a verification link to your email address. Please click the link to verify your account.",
    checkEmailHint: "Didn't receive the email? Check your spam folder. The verification link expires in 60 minutes.",
    travelInfo: 'If you are already planning to travel and would like to volunteer, please register your interest. Volunteering is based on personal arrangements, and all travel, accommodation, visa, and related requirements must be arranged independently.',
    accountInfoTitle: 'Account Information',
    emailPlaceholder: 'Email address',
    passwordPlaceholder: 'Password',
    rePasswordPlaceholder: 'Re-Enter Password',
    volunteerInfoTitle: 'Volunteer Information',
    firstNamePlaceholder: 'First Name',
    lastNamePlaceholder: 'Last Name',
    selectGender: 'Select Gender',
    male: 'Male',
    female: 'Female',
    preferNotToSay: 'Prefer Not to Say',
    countryCodePlaceholder: 'Country Code e.g: +44',
    phonePlaceholder: 'Phone Number',
    countryPlaceholder: 'Country',
    jamatkhanaPlaceholder: 'Jamatkhana',
    familyOriginLabel: 'Family Origin',
    selectOrigin: 'Select Origin',
    additionalDetailsTitle: 'Additional Details',
    ismaili: 'Ismaili',
    interFaithFamily: 'Inter-faith family',
    languagesLabel: 'Languages',
    supportNeedsPlaceholder: 'Any additional support needs…',
    registerButton: 'Register',
    registering: 'Registering…',
    passwordsDoNotMatch: 'Passwords do not match.',
    faithStatusRequired: 'Please select either Ismaili or Inter-faith family.',
    invalidDob: 'Please enter a valid date of birth.'
}

export const VerifyEmailMeta: VerifyEmailMetaProps = {
    title: 'Email Verification',
    verifying: 'Verifying your email...',
    successTitle: 'Email Verified Successfully!',
    successMessage: 'Thank you for registering as a volunteer for the United Kingdom Visit.',
    reviewMessage: 'Your volunteer registration request is currently under review.',
    approvalNotice: 'You will receive an email notification once your registration has been approved by our team.',
    travelInfo: 'If you are already planning to travel and would like to volunteer, please register your interest. Volunteering is based on personal arrangements, and all travel, accommodation, visa, and related requirements must be arranged independently.',
    backToLogin: 'Back to Login',
    backToSignup: 'Back to Signup',
    sending: 'Sending...',
    resendVerification: 'Resend Verification Email',
    invalidLinkError: 'Invalid verification link. Please check the link in your email.'
}

export const HouseholdSelectionMeta: HouseholdSelectionMetaProps = {
    errorTitle: 'Error',
    returnToLogin: 'Return to Login',
    title: 'Select Household Member',
    description: 'Please select which member of your household you would like to use the platform as.',
    youBadge: 'You',
    cancel: 'Cancel',
    loadError: 'Failed to load household members. Please try logging in again.'
}

export const CheckInLoginFormMeta: CheckInLoginFormMetaProps = {
    errorLabel: 'Error:',
    title: 'Login for Check-ins',
    usernameLabel: 'Username',
    usernamePlaceholder: 'Enter your username',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Enter your password',
    loginButton: 'Login'
}

export const ApprovedCountries = [
    'Austria',
    'Germany',
    'Italy',
    'Poland',
    'Denmark',
    'Finland',
    'Netherlands',
    'Norway',
    'Sweden',
    'Bulgaria',
    'Czech Republic',
    'Estonia',
    'Greece',
    'Hungary',
    'Latvia',
    'Lithuania',
    'Malta',
    'North Macedonia',
    'Romania',
    'Slovakia',
    'Slovenia',
    'North Cyprus',
    'Turkey',
    //'Türkiye',
]

export const EU_JAMAT_KHANA_OPTIONS = [
    'amsterdam',
    'bad salzuflen',
    'berlin',
    'bologna',
    'bosel',
    'bulgaria',
    'cologne',
    'copenhagen',
    'czech',
    'dresden',
    'eindhoven',
    'erfurt',
    'essen',
    'estonia',
    'frankfurt',
    'gothenburg',
    'graz',
    'greece',
    'hamburg',
    'helsinki',
    'hungary',
    'kassel',
    'krakow',
    'latvia',
    'leipzig',
    'linz',
    'lithuania',
    'ljungby',
    'malmo',
    'malta',
    'munich',
    'nicosia',
    'north macedonia',
    'orebro',
    'oslo',
    'romania',
    'rome',
    'rotterdam',
    'rzeszow',
    'slovakia',
    'slovenia',
    'stockholm',
    'stuttgart',
    'szczecin',
    'turkey',
    'umea',
    'vanersborg',
    'vienna',
    'warsaw',
    'wuppertal',
    'zevenaar',
];


export const GuidelineFormModalMeta: GuidelineFormModalMetaProps = {
    title: 'Create Guideline',
    nameLabel: 'Name',
    namePlaceholder: 'Name...',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'description...',
    audienceLabel: 'Who can see this guideline?',
    audienceAllOption: 'Select All',
    audienceServiceRecordOption: 'Select IV Positions',
    addModuleButton: 'Add Content',
    noModulesMessage: 'No Content Avaiable',
    uploadButton: 'Save Guideline',
    uploadingLabel: 'Saving...',
    cancelButton: 'Cancel',
    submitButton: 'Submit',
    submittingButton: 'Submitting...'
}

export const AdminGuidelinesMeta: AdminGuidelinesMetaProps = {
    title: 'Guidelines',
    description: 'Manage reference guidelines for volunteers',
    errorTitle: 'Error',
    noGuidelinesMessage: 'No guidelines yet',
    loadingText: 'Loading...'
}

export const VolunteerGuidelinesMeta: VolunteerGuidelinesMetaProps = {
    title: 'Guidelines',
    errorTitle: 'Error',
    noGuidelinesMessage: 'No guidelines available',
    documentsLabel: 'document(s)'
}

export const GuidelineDetailsMeta: GuidelineDetailsMetaProps = {
    backButtonLabel: 'Back to Guidelines',
    errorTitle: 'Error',
    notFoundMessage: 'Guideline not found'
}

export const JVPointsMeta: JVPointsMetaProps = {
    title: 'Junior Volunteer Points',
    description: 'View total points earned by junior volunteers'
}

export const DirectorVolunteerMeta: DirectorVolunteerMetaProps = {
    title: "Jamat Khana Volunteers",
    description: "View volunteers of your jamat khana"
}
